import {UserAddress} from "../types/models/user_address";
import * as _ from 'lodash';

export interface Country {
  countryId: string;
  displayValue: string;
  stateDisplayValue: null | string;
  cityDisplayValue: null | string;
  postalCodeRequired: boolean;
  stateRequired: boolean;
  cityRequired?: boolean;
  postalCodeRegex: null | string;
  displayFormat: string;
  states: Record<string, CountryState>;
}

export interface CountryState {
  stateValue: string;
  displayValue: string;
}

interface CountryAndState {
  countries: {
    [countryCode: string]: Country;
  };
}

// source: https://github.com/Shopify/quilt/tree/main/packages/address-mocks/src/fixtures

const countriesAndStates: CountryAndState = {
  "countries": {
    "AC": {
      "countryId": "AC",
      "displayValue": "Ascension island",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "ASCN 1ZZ"
    },
    "AD": {
      "countryId": "AD",
      "displayValue": "Andorra",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "07": {
          "stateValue": "07",
          "displayValue": "Andorra la Vella"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Canillo"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Encamp"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Escaldes-Engordany"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "La Massana"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Ordino"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Sant Julià de Lòria"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "AD[1-7]0\\d"
    },
    "AE": {
      "countryId": "AE",
      "displayValue": "United Arab Emirates",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Emirate",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "AZ": {
          "stateValue": "AZ",
          "displayValue": "Abu Dhabi"
        },
        "SH": {
          "stateValue": "SH",
          "displayValue": "Sharjah"
        },
        "FU": {
          "stateValue": "FU",
          "displayValue": "Fujairah"
        },
        "UQ": {
          "stateValue": "UQ",
          "displayValue": "Umm Al Quwain"
        },
        "DU": {
          "stateValue": "DU",
          "displayValue": "Dubai"
        },
        "RK": {
          "stateValue": "RK",
          "displayValue": "Ras al Khaimah"
        },
        "AJ": {
          "stateValue": "AJ",
          "displayValue": "Ajman"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "AF": {
      "countryId": "AF",
      "displayValue": "Afghanistan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "AG": {
      "countryId": "AG",
      "displayValue": "Antigua and Barbuda",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "AI": {
      "countryId": "AI",
      "displayValue": "Anguilla",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:AI-)?2640"
    },
    "AL": {
      "countryId": "AL",
      "displayValue": "Albania",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "AM": {
      "countryId": "AM",
      "displayValue": "Armenia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "AG": {
          "stateValue": "AG",
          "displayValue": "Aragatsotn"
        },
        "AR": {
          "stateValue": "AR",
          "displayValue": "Ararat"
        },
        "AV": {
          "stateValue": "AV",
          "displayValue": "Armavir"
        },
        "GR": {
          "stateValue": "GR",
          "displayValue": "Gegharkunik"
        },
        "ER": {
          "stateValue": "ER",
          "displayValue": "Yerevan"
        },
        "LO": {
          "stateValue": "LO",
          "displayValue": "Lori"
        },
        "KT": {
          "stateValue": "KT",
          "displayValue": "Kotayk"
        },
        "SH": {
          "stateValue": "SH",
          "displayValue": "Shirak"
        },
        "SU": {
          "stateValue": "SU",
          "displayValue": "Syunik"
        },
        "VD": {
          "stateValue": "VD",
          "displayValue": "Vayots Dzor"
        },
        "TV": {
          "stateValue": "TV",
          "displayValue": "Tavush"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:37)?\\d{4}"
    },
    "AO": {
      "countryId": "AO",
      "displayValue": "Angola",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "AQ": {
      "countryId": "AQ",
      "displayValue": "Antarctica",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "AR": {
      "countryId": "AR",
      "displayValue": "Argentina",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "B": {
          "stateValue": "B",
          "displayValue": "Buenos Aires"
        },
        "K": {
          "stateValue": "K",
          "displayValue": "Catamarca"
        },
        "H": {
          "stateValue": "H",
          "displayValue": "Chaco"
        },
        "U": {
          "stateValue": "U",
          "displayValue": "Chubut"
        },
        "C": {
          "stateValue": "C",
          "displayValue": "Ciudad Autónoma de Buenos Aires"
        },
        "X": {
          "stateValue": "X",
          "displayValue": "Córdoba"
        },
        "W": {
          "stateValue": "W",
          "displayValue": "Corrientes"
        },
        "E": {
          "stateValue": "E",
          "displayValue": "Entre Ríos"
        },
        "P": {
          "stateValue": "P",
          "displayValue": "Formosa"
        },
        "Y": {
          "stateValue": "Y",
          "displayValue": "Jujuy"
        },
        "L": {
          "stateValue": "L",
          "displayValue": "La Pampa"
        },
        "F": {
          "stateValue": "F",
          "displayValue": "La Rioja"
        },
        "M": {
          "stateValue": "M",
          "displayValue": "Mendoza"
        },
        "N": {
          "stateValue": "N",
          "displayValue": "Misiones"
        },
        "Q": {
          "stateValue": "Q",
          "displayValue": "Neuquén"
        },
        "R": {
          "stateValue": "R",
          "displayValue": "Río Negro"
        },
        "A": {
          "stateValue": "A",
          "displayValue": "Salta"
        },
        "J": {
          "stateValue": "J",
          "displayValue": "San Juan"
        },
        "D": {
          "stateValue": "D",
          "displayValue": "San Luis"
        },
        "Z": {
          "stateValue": "Z",
          "displayValue": "Santa Cruz"
        },
        "S": {
          "stateValue": "S",
          "displayValue": "Santa Fe"
        },
        "G": {
          "stateValue": "G",
          "displayValue": "Santiago del Estero"
        },
        "V": {
          "stateValue": "V",
          "displayValue": "Tierra del Fuego"
        },
        "T": {
          "stateValue": "T",
          "displayValue": "Tucumán"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?"
    },
    "AS": {
      "countryId": "AS",
      "displayValue": "American Samoa",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(96799)(?:[ \\-](\\d{4}))?"
    },
    "AT": {
      "countryId": "AT",
      "displayValue": "Austria",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "AU": {
      "countryId": "AU",
      "displayValue": "Australia",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "Suburb",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "ACT": {
          "stateValue": "ACT",
          "displayValue": "Australian Capital Territory"
        },
        "JBT": {
          "stateValue": "JBT",
          "displayValue": "Jervis Bay Territory"
        },
        "NSW": {
          "stateValue": "NSW",
          "displayValue": "New South Wales"
        },
        "NT": {
          "stateValue": "NT",
          "displayValue": "Northern Territory"
        },
        "QLD": {
          "stateValue": "QLD",
          "displayValue": "Queensland"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "South Australia"
        },
        "TAS": {
          "stateValue": "TAS",
          "displayValue": "Tasmania"
        },
        "VIC": {
          "stateValue": "VIC",
          "displayValue": "Victoria"
        },
        "WA": {
          "stateValue": "WA",
          "displayValue": "Western Australia"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "AW": {
      "countryId": "AW",
      "displayValue": "Aruba",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "AX": {
      "countryId": "AX",
      "displayValue": "Åland Islands",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_AX-{zip} {city}_ÅLAND_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "22\\d{3}"
    },
    "AZ": {
      "countryId": "AZ",
      "displayValue": "Azerbaijan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_AZ {zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "BA": {
      "countryId": "BA",
      "displayValue": "Bosnia and Herzegovina",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "BB": {
      "countryId": "BB",
      "displayValue": "Barbados",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Parish",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "BB\\d{5}"
    },
    "BD": {
      "countryId": "BD",
      "displayValue": "Bangladesh",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} - {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "BE": {
      "countryId": "BE",
      "displayValue": "Belgium",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "BF": {
      "countryId": "BF",
      "displayValue": "Burkina Faso",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BG": {
      "countryId": "BG",
      "displayValue": "Bulgaria",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "BH": {
      "countryId": "BH",
      "displayValue": "Bahrain",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:^|\\b)(?:1[0-2]|[1-9])\\d{2}(?:$|\\b)"
    },
    "BI": {
      "countryId": "BI",
      "displayValue": "Burundi",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BJ": {
      "countryId": "BJ",
      "displayValue": "Benin",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BL": {
      "countryId": "BL",
      "displayValue": "Saint Barthélemy",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78][01]\\d{2}"
    },
    "BM": {
      "countryId": "BM",
      "displayValue": "Bermuda",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "[A-Z]{2} ?[A-Z0-9]{2}"
    },
    "BN": {
      "countryId": "BN",
      "displayValue": "Brunei",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "[A-Z]{2} ?\\d{4}"
    },
    "BO": {
      "countryId": "BO",
      "displayValue": "Bolivia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BQ": {
      "countryId": "BQ",
      "displayValue": "Bonaire",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BR": {
      "countryId": "BR",
      "displayValue": "Brazil",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}__{city}-{state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AC": {
          "stateValue": "AC",
          "displayValue": "Acre"
        },
        "AL": {
          "stateValue": "AL",
          "displayValue": "Alagoas"
        },
        "AP": {
          "stateValue": "AP",
          "displayValue": "Amapá"
        },
        "AM": {
          "stateValue": "AM",
          "displayValue": "Amazonas"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Bahia"
        },
        "CE": {
          "stateValue": "CE",
          "displayValue": "Ceará"
        },
        "DF": {
          "stateValue": "DF",
          "displayValue": "Distrito Federal"
        },
        "ES": {
          "stateValue": "ES",
          "displayValue": "Espírito Santo"
        },
        "GO": {
          "stateValue": "GO",
          "displayValue": "Goiás"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Maranhão"
        },
        "MT": {
          "stateValue": "MT",
          "displayValue": "Mato Grosso"
        },
        "MS": {
          "stateValue": "MS",
          "displayValue": "Mato Grosso do Sul"
        },
        "MG": {
          "stateValue": "MG",
          "displayValue": "Minas Gerais"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "Pará"
        },
        "PB": {
          "stateValue": "PB",
          "displayValue": "Paraíba"
        },
        "PR": {
          "stateValue": "PR",
          "displayValue": "Paraná"
        },
        "PE": {
          "stateValue": "PE",
          "displayValue": "Pernambuco"
        },
        "PI": {
          "stateValue": "PI",
          "displayValue": "Piauí"
        },
        "RJ": {
          "stateValue": "RJ",
          "displayValue": "Rio de Janeiro"
        },
        "RN": {
          "stateValue": "RN",
          "displayValue": "Rio Grande do Norte"
        },
        "RS": {
          "stateValue": "RS",
          "displayValue": "Rio Grande do Sul"
        },
        "RO": {
          "stateValue": "RO",
          "displayValue": "Rondônia"
        },
        "RR": {
          "stateValue": "RR",
          "displayValue": "Roraima"
        },
        "SC": {
          "stateValue": "SC",
          "displayValue": "Santa Catarina"
        },
        "SP": {
          "stateValue": "SP",
          "displayValue": "São Paulo"
        },
        "SE": {
          "stateValue": "SE",
          "displayValue": "Sergipe"
        },
        "TO": {
          "stateValue": "TO",
          "displayValue": "Tocantins"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}-?\\d{3}"
    },
    "BS": {
      "countryId": "BS",
      "displayValue": "The Bahamas",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "Abaco": {
          "stateValue": "Abaco",
          "displayValue": "Abaco Islands"
        },
        "AK": {
          "stateValue": "AK",
          "displayValue": "Acklins"
        },
        "Andros": {
          "stateValue": "Andros",
          "displayValue": "Andros Island"
        },
        "BY": {
          "stateValue": "BY",
          "displayValue": "Berry Islands"
        },
        "BI": {
          "stateValue": "BI",
          "displayValue": "Bimini"
        },
        "CI": {
          "stateValue": "CI",
          "displayValue": "Cat Island"
        },
        "Crooked Island": {
          "stateValue": "Crooked Island",
          "displayValue": "Crooked Island"
        },
        "Eleuthera": {
          "stateValue": "Eleuthera",
          "displayValue": "Eleuthera"
        },
        "EX": {
          "stateValue": "EX",
          "displayValue": "Exuma and Cays"
        },
        "Grand Bahama": {
          "stateValue": "Grand Bahama",
          "displayValue": "Grand Bahama"
        },
        "HI": {
          "stateValue": "HI",
          "displayValue": "Harbour Island"
        },
        "IN": {
          "stateValue": "IN",
          "displayValue": "Inagua"
        },
        "LI": {
          "stateValue": "LI",
          "displayValue": "Long Island"
        },
        "MG": {
          "stateValue": "MG",
          "displayValue": "Mayaguana"
        },
        "N.P.": {
          "stateValue": "N.P.",
          "displayValue": "New Providence"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Ragged Island"
        },
        "RC": {
          "stateValue": "RC",
          "displayValue": "Rum Cay"
        },
        "SS": {
          "stateValue": "SS",
          "displayValue": "San Salvador"
        },
        "SW": {
          "stateValue": "SW",
          "displayValue": "Spanish Wells"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BT": {
      "countryId": "BT",
      "displayValue": "Bhutan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "BV": {
      "countryId": "BV",
      "displayValue": "Bouvet Island",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BW": {
      "countryId": "BW",
      "displayValue": "Botswana",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "BY": {
      "countryId": "BY",
      "displayValue": "Belarus",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip}, {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "BZ": {
      "countryId": "BZ",
      "displayValue": "Belize",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CA": {
      "countryId": "CA",
      "displayValue": "Canada",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AB": {
          "stateValue": "AB",
          "displayValue": "Alberta"
        },
        "BC": {
          "stateValue": "BC",
          "displayValue": "British Columbia"
        },
        "MB": {
          "stateValue": "MB",
          "displayValue": "Manitoba"
        },
        "NB": {
          "stateValue": "NB",
          "displayValue": "New Brunswick"
        },
        "NL": {
          "stateValue": "NL",
          "displayValue": "Newfoundland and Labrador"
        },
        "NT": {
          "stateValue": "NT",
          "displayValue": "Northwest Territories"
        },
        "NS": {
          "stateValue": "NS",
          "displayValue": "Nova Scotia"
        },
        "NU": {
          "stateValue": "NU",
          "displayValue": "Nunavut"
        },
        "ON": {
          "stateValue": "ON",
          "displayValue": "Ontario"
        },
        "PE": {
          "stateValue": "PE",
          "displayValue": "Prince Edward Island"
        },
        "QC": {
          "stateValue": "QC",
          "displayValue": "Quebec"
        },
        "SK": {
          "stateValue": "SK",
          "displayValue": "Saskatchewan"
        },
        "YT": {
          "stateValue": "YT",
          "displayValue": "Yukon"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d"
    },
    "CC": {
      "countryId": "CC",
      "displayValue": "Cocos (Keeling) Islands",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "6799"
    },
    "CD": {
      "countryId": "CD",
      "displayValue": "Democratic Republic of the Congo",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CF": {
      "countryId": "CF",
      "displayValue": "Central African Republic",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CG": {
      "countryId": "CG",
      "displayValue": "Republic of the Congo",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CH": {
      "countryId": "CH",
      "displayValue": "Switzerland",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_CH-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "CI": {
      "countryId": "CI",
      "displayValue": "Ivory Coast",
      "displayFormat": "{firstName} {lastName}_{company}_ {address1}_{address2} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CK": {
      "countryId": "CK",
      "displayValue": "Cook Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CL": {
      "countryId": "CL",
      "displayValue": "Chile",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "AN": {
          "stateValue": "AN",
          "displayValue": "Antofagasta"
        },
        "AR": {
          "stateValue": "AR",
          "displayValue": "Araucanía"
        },
        "AP": {
          "stateValue": "AP",
          "displayValue": "Arica y Parinacota"
        },
        "AT": {
          "stateValue": "AT",
          "displayValue": "Atacama"
        },
        "AI": {
          "stateValue": "AI",
          "displayValue": "Aysén del General Carlos Ibáñez del Campo"
        },
        "BI": {
          "stateValue": "BI",
          "displayValue": "Biobío"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Coquimbo"
        },
        "LI": {
          "stateValue": "LI",
          "displayValue": "Libertador General Bernardo O'Higgins"
        },
        "LL": {
          "stateValue": "LL",
          "displayValue": "Los Lagos"
        },
        "LR": {
          "stateValue": "LR",
          "displayValue": "Los Ríos"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Magallanes y de la Antártica Chilena"
        },
        "ML": {
          "stateValue": "ML",
          "displayValue": "Maule"
        },
        "RM": {
          "stateValue": "RM",
          "displayValue": "Metropolitana de Santiago"
        },
        "NB": {
          "stateValue": "NB",
          "displayValue": "Ñuble"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Tarapacá"
        },
        "VS": {
          "stateValue": "VS",
          "displayValue": "Valparaíso"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{7}"
    },
    "CM": {
      "countryId": "CM",
      "displayValue": "Cameroon",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CN": {
      "countryId": "CN",
      "displayValue": "China",
      "displayFormat": "{zip}_{state}{city}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "11": {
          "stateValue": "11",
          "displayValue": "Beijing Shi"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Tianjin Shi"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Hebei Sheng"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Shanxi Sheng"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Neimenggu Zizhiqu"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Liaoning Sheng"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Jilin Sheng"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Heilongjiang Sheng"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Shanghai Shi"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Jiangsu Sheng"
        },
        "33": {
          "stateValue": "33",
          "displayValue": "Zhejiang Sheng"
        },
        "34": {
          "stateValue": "34",
          "displayValue": "Anhui Sheng"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "Fujian Sheng"
        },
        "36": {
          "stateValue": "36",
          "displayValue": "Jiangxi Sheng"
        },
        "37": {
          "stateValue": "37",
          "displayValue": "Shandong Sheng"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Henan Sheng"
        },
        "42": {
          "stateValue": "42",
          "displayValue": "Hubei Sheng"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Hunan Sheng"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "Guangdong Sheng"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Guangxi Zhuangzuzizhiqu"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Hainan Sheng"
        },
        "50": {
          "stateValue": "50",
          "displayValue": "Chongqing Shi"
        },
        "51": {
          "stateValue": "51",
          "displayValue": "Sichuan Sheng"
        },
        "52": {
          "stateValue": "52",
          "displayValue": "Guizhou Sheng"
        },
        "53": {
          "stateValue": "53",
          "displayValue": "Yunnan Sheng"
        },
        "54": {
          "stateValue": "54",
          "displayValue": "Xizang Zizhiqu"
        },
        "61": {
          "stateValue": "61",
          "displayValue": "Shaanxi Sheng"
        },
        "62": {
          "stateValue": "62",
          "displayValue": "Gansu Sheng"
        },
        "63": {
          "stateValue": "63",
          "displayValue": "Qinghai Sheng"
        },
        "64": {
          "stateValue": "64",
          "displayValue": "Ningxia Huizuzizhiqu"
        },
        "65": {
          "stateValue": "65",
          "displayValue": "Xinjiang Weiwuerzizhiqu"
        },
        "71": {
          "stateValue": "71",
          "displayValue": "Taiwan"
        },
        "91": {
          "stateValue": "91",
          "displayValue": "Hong Kong"
        },
        "92": {
          "stateValue": "92",
          "displayValue": "Macau"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{6}"
    },
    "CO": {
      "countryId": "CO",
      "displayValue": "Colombia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city}, {state}, {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Department",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "AMA": {
          "stateValue": "AMA",
          "displayValue": "Amazonas"
        },
        "ANT": {
          "stateValue": "ANT",
          "displayValue": "Antioquia"
        },
        "ARA": {
          "stateValue": "ARA",
          "displayValue": "Arauca"
        },
        "ATL": {
          "stateValue": "ATL",
          "displayValue": "Atlántico"
        },
        "DC": {
          "stateValue": "DC",
          "displayValue": "Bogotá"
        },
        "BOL": {
          "stateValue": "BOL",
          "displayValue": "Bolívar"
        },
        "BOY": {
          "stateValue": "BOY",
          "displayValue": "Boyacá"
        },
        "CAL": {
          "stateValue": "CAL",
          "displayValue": "Caldas"
        },
        "CAQ": {
          "stateValue": "CAQ",
          "displayValue": "Caquetá"
        },
        "CAS": {
          "stateValue": "CAS",
          "displayValue": "Casanare"
        },
        "CAU": {
          "stateValue": "CAU",
          "displayValue": "Cauca"
        },
        "CES": {
          "stateValue": "CES",
          "displayValue": "Cesar"
        },
        "CHO": {
          "stateValue": "CHO",
          "displayValue": "Chocó"
        },
        "COR": {
          "stateValue": "COR",
          "displayValue": "Córdoba"
        },
        "CUN": {
          "stateValue": "CUN",
          "displayValue": "Cundinamarca"
        },
        "GUA": {
          "stateValue": "GUA",
          "displayValue": "Guainía"
        },
        "GUV": {
          "stateValue": "GUV",
          "displayValue": "Guaviare"
        },
        "HUI": {
          "stateValue": "HUI",
          "displayValue": "Huila"
        },
        "LAG": {
          "stateValue": "LAG",
          "displayValue": "La Guajira"
        },
        "MAG": {
          "stateValue": "MAG",
          "displayValue": "Magdalena"
        },
        "MET": {
          "stateValue": "MET",
          "displayValue": "Meta"
        },
        "NAR": {
          "stateValue": "NAR",
          "displayValue": "Nariño"
        },
        "NSA": {
          "stateValue": "NSA",
          "displayValue": "Norte de Santander"
        },
        "PUT": {
          "stateValue": "PUT",
          "displayValue": "Putumayo"
        },
        "QUI": {
          "stateValue": "QUI",
          "displayValue": "Quindío"
        },
        "RIS": {
          "stateValue": "RIS",
          "displayValue": "Risaralda"
        },
        "SAP": {
          "stateValue": "SAP",
          "displayValue": "San Andrés y Providencia"
        },
        "SAN": {
          "stateValue": "SAN",
          "displayValue": "Santander"
        },
        "SUC": {
          "stateValue": "SUC",
          "displayValue": "Sucre"
        },
        "TOL": {
          "stateValue": "TOL",
          "displayValue": "Tolima"
        },
        "VAC": {
          "stateValue": "VAC",
          "displayValue": "Valle del Cauca"
        },
        "VAU": {
          "stateValue": "VAU",
          "displayValue": "Vaupés"
        },
        "VID": {
          "stateValue": "VID",
          "displayValue": "Vichada"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "CR": {
      "countryId": "CR",
      "displayValue": "Costa Rica",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state}, {city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4,5}|\\d{3}-\\d{4}"
    },
    "CU": {
      "countryId": "CU",
      "displayValue": "Cuba",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Las Tunas"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Holguín"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Granma"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Santiago de Cuba"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Guantánamo"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Artemisa"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Mayabeque"
        },
        "99": {
          "stateValue": "99",
          "displayValue": "Isla de la Juventud"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Camagüey"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Ciego de Ávila"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Cienfuegos"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "La Habana"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Matanzas"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Pinar del Río"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Sancti Spíritus"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Villa Clara"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "CV": {
      "countryId": "CV",
      "displayValue": "Cape Verde",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "BV": {
          "stateValue": "BV",
          "displayValue": "Boa Vista"
        },
        "BR": {
          "stateValue": "BR",
          "displayValue": "Brava"
        },
        "Fogo": {
          "stateValue": "Fogo",
          "displayValue": "Fogo"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Maio"
        },
        "SL": {
          "stateValue": "SL",
          "displayValue": "Sal"
        },
        "Santiago": {
          "stateValue": "Santiago",
          "displayValue": "Santiago"
        },
        "Santo Antão": {
          "stateValue": "Santo Antão",
          "displayValue": "Santo Antão"
        },
        "São Nicolau": {
          "stateValue": "São Nicolau",
          "displayValue": "São Nicolau"
        },
        "SV": {
          "stateValue": "SV",
          "displayValue": "São Vicente"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "CW": {
      "countryId": "CW",
      "displayValue": "Curaçao",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "CX": {
      "countryId": "CX",
      "displayValue": "Christmas Island",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "6798"
    },
    "CY": {
      "countryId": "CY",
      "displayValue": "Cyprus",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "CZ": {
      "countryId": "CZ",
      "displayValue": "Czech Republic",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3} ?\\d{2}"
    },
    "DE": {
      "countryId": "DE",
      "displayValue": "Germany",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "DJ": {
      "countryId": "DJ",
      "displayValue": "Djibouti",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "DK": {
      "countryId": "DK",
      "displayValue": "Denmark",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "DM": {
      "countryId": "DM",
      "displayValue": "Dominica",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "DO": {
      "countryId": "DO",
      "displayValue": "Dominican Republic",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "DZ": {
      "countryId": "DZ",
      "displayValue": "Algeria",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "EC": {
      "countryId": "EC",
      "displayValue": "Ecuador",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "EE": {
      "countryId": "EE",
      "displayValue": "Estonia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "EG": {
      "countryId": "EG",
      "displayValue": "Egypt",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "ASN": {
          "stateValue": "ASN",
          "displayValue": "Aswan Governorate"
        },
        "AST": {
          "stateValue": "AST",
          "displayValue": "Asyut Governorate"
        },
        "ALX": {
          "stateValue": "ALX",
          "displayValue": "Alexandria Governorate"
        },
        "IS": {
          "stateValue": "IS",
          "displayValue": "Ismailia Governorate"
        },
        "LX": {
          "stateValue": "LX",
          "displayValue": "Luxor Governorate"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Red Sea Governorate"
        },
        "BH": {
          "stateValue": "BH",
          "displayValue": "El Beheira Governorate"
        },
        "GZ": {
          "stateValue": "GZ",
          "displayValue": "Giza Governorate"
        },
        "DK": {
          "stateValue": "DK",
          "displayValue": "Dakahlia Governorate"
        },
        "SUZ": {
          "stateValue": "SUZ",
          "displayValue": "Suez Governorate"
        },
        "SHR": {
          "stateValue": "SHR",
          "displayValue": "Ash Sharqia Governorate"
        },
        "GH": {
          "stateValue": "GH",
          "displayValue": "Gharbia Governorate"
        },
        "FYM": {
          "stateValue": "FYM",
          "displayValue": "Faiyum Governorate"
        },
        "C": {
          "stateValue": "C",
          "displayValue": "Cairo Governorate"
        },
        "KB": {
          "stateValue": "KB",
          "displayValue": "Qalyubia Governorate"
        },
        "MNF": {
          "stateValue": "MNF",
          "displayValue": "Menofia Governorate"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Menia Governorate"
        },
        "WAD": {
          "stateValue": "WAD",
          "displayValue": "New Valley Governorate"
        },
        "BNS": {
          "stateValue": "BNS",
          "displayValue": "Beni Suef Governorate"
        },
        "PTS": {
          "stateValue": "PTS",
          "displayValue": "Port Said Governorate"
        },
        "JS": {
          "stateValue": "JS",
          "displayValue": "South Sinai Governorate"
        },
        "DT": {
          "stateValue": "DT",
          "displayValue": "Damietta Governorate"
        },
        "SHG": {
          "stateValue": "SHG",
          "displayValue": "Sohag Governorate"
        },
        "SIN": {
          "stateValue": "SIN",
          "displayValue": "North Sinai Governorate"
        },
        "KN": {
          "stateValue": "KN",
          "displayValue": "Qena Governorate"
        },
        "KFS": {
          "stateValue": "KFS",
          "displayValue": "Kafr El Sheikh Governorate"
        },
        "MT": {
          "stateValue": "MT",
          "displayValue": "Matrouh Governorate"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "EH": {
      "countryId": "EH",
      "displayValue": "Western Sahara",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "ER": {
      "countryId": "ER",
      "displayValue": "Eritrea",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "ES": {
      "countryId": "ES",
      "displayValue": "Spain",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "VI": {
          "stateValue": "VI",
          "displayValue": "Álava"
        },
        "AB": {
          "stateValue": "AB",
          "displayValue": "Albacete"
        },
        "A": {
          "stateValue": "A",
          "displayValue": "Alicante"
        },
        "AL": {
          "stateValue": "AL",
          "displayValue": "Almería"
        },
        "O": {
          "stateValue": "O",
          "displayValue": "Asturias"
        },
        "AV": {
          "stateValue": "AV",
          "displayValue": "Ávila"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Badajoz"
        },
        "B": {
          "stateValue": "B",
          "displayValue": "Barcelona"
        },
        "BU": {
          "stateValue": "BU",
          "displayValue": "Burgos"
        },
        "CC": {
          "stateValue": "CC",
          "displayValue": "Cáceres"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "Cádiz"
        },
        "S": {
          "stateValue": "S",
          "displayValue": "Cantabria"
        },
        "CS": {
          "stateValue": "CS",
          "displayValue": "Castellón"
        },
        "CE": {
          "stateValue": "CE",
          "displayValue": "Ceuta"
        },
        "CR": {
          "stateValue": "CR",
          "displayValue": "Ciudad Real"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Córdoba"
        },
        "CU": {
          "stateValue": "CU",
          "displayValue": "Cuenca"
        },
        "GI": {
          "stateValue": "GI",
          "displayValue": "Girona"
        },
        "GR": {
          "stateValue": "GR",
          "displayValue": "Granada"
        },
        "GU": {
          "stateValue": "GU",
          "displayValue": "Guadalajara"
        },
        "SS": {
          "stateValue": "SS",
          "displayValue": "Guipúzcoa"
        },
        "H": {
          "stateValue": "H",
          "displayValue": "Huelva"
        },
        "HU": {
          "stateValue": "HU",
          "displayValue": "Huesca"
        },
        "PM": {
          "stateValue": "PM",
          "displayValue": "Islas Baleares"
        },
        "J": {
          "stateValue": "J",
          "displayValue": "Jaén"
        },
        "C": {
          "stateValue": "C",
          "displayValue": "La Coruña"
        },
        "LO": {
          "stateValue": "LO",
          "displayValue": "La Rioja"
        },
        "GC": {
          "stateValue": "GC",
          "displayValue": "Las Palmas"
        },
        "LE": {
          "stateValue": "LE",
          "displayValue": "León"
        },
        "L": {
          "stateValue": "L",
          "displayValue": "Lérida"
        },
        "LU": {
          "stateValue": "LU",
          "displayValue": "Lugo"
        },
        "M": {
          "stateValue": "M",
          "displayValue": "Madrid"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Málaga"
        },
        "ML": {
          "stateValue": "ML",
          "displayValue": "Melilla"
        },
        "MU": {
          "stateValue": "MU",
          "displayValue": "Murcia"
        },
        "NA": {
          "stateValue": "NA",
          "displayValue": "Navarra"
        },
        "OR": {
          "stateValue": "OR",
          "displayValue": "Ourense"
        },
        "P": {
          "stateValue": "P",
          "displayValue": "Palencia"
        },
        "PO": {
          "stateValue": "PO",
          "displayValue": "Pontevedra"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Salamanca"
        },
        "TF": {
          "stateValue": "TF",
          "displayValue": "Santa Cruz de Tenerife"
        },
        "SG": {
          "stateValue": "SG",
          "displayValue": "Segovia"
        },
        "SE": {
          "stateValue": "SE",
          "displayValue": "Sevilla"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Soria"
        },
        "T": {
          "stateValue": "T",
          "displayValue": "Tarragona"
        },
        "TE": {
          "stateValue": "TE",
          "displayValue": "Teruel"
        },
        "TO": {
          "stateValue": "TO",
          "displayValue": "Toledo"
        },
        "V": {
          "stateValue": "V",
          "displayValue": "Valencia"
        },
        "VA": {
          "stateValue": "VA",
          "displayValue": "Valladolid"
        },
        "BI": {
          "stateValue": "BI",
          "displayValue": "Vizcaya"
        },
        "ZA": {
          "stateValue": "ZA",
          "displayValue": "Zamora"
        },
        "Z": {
          "stateValue": "Z",
          "displayValue": "Zaragoza"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "ET": {
      "countryId": "ET",
      "displayValue": "Ethiopia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "FI": {
      "countryId": "FI",
      "displayValue": "Finland",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_FI-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "FJ": {
      "countryId": "FJ",
      "displayValue": "Fiji",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "FK": {
      "countryId": "FK",
      "displayValue": "Falkland Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "FIQQ 1ZZ"
    },
    "FM": {
      "countryId": "FM",
      "displayValue": "Federated States of Micronesia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(9694[1-4])(?:[ \\-](\\d{4}))?"
    },
    "FO": {
      "countryId": "FO",
      "displayValue": "Faroe Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_FO{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "FR": {
      "countryId": "FR",
      "displayValue": "France",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{2} ?\\d{3}"
    },
    "GA": {
      "countryId": "GA",
      "displayValue": "Gabon",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "GB": {
      "countryId": "GB",
      "displayValue": "United Kingdom",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "Post town",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}"
    },
    "GD": {
      "countryId": "GD",
      "displayValue": "Grenada",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "GE": {
      "countryId": "GE",
      "displayValue": "Georgia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "GF": {
      "countryId": "GF",
      "displayValue": "French Guiana",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78]3\\d{2}"
    },
    "GG": {
      "countryId": "GG",
      "displayValue": "Guernsey",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_GUERNSEY_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}"
    },
    "GH": {
      "countryId": "GH",
      "displayValue": "Ghana",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "GI": {
      "countryId": "GI",
      "displayValue": "Gibraltar",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_GIBRALTAR_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "GX11 1AA"
    },
    "GL": {
      "countryId": "GL",
      "displayValue": "Greenland",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "39\\d{2}"
    },
    "GM": {
      "countryId": "GM",
      "displayValue": "The Gambia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "GN": {
      "countryId": "GN",
      "displayValue": "Guinea",
      "displayFormat": "{firstName} {lastName}_{company}_{zip} {address1}_{address2} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "GP": {
      "countryId": "GP",
      "displayValue": "Guadeloupe",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78][01]\\d{2}"
    },
    "GQ": {
      "countryId": "GQ",
      "displayValue": "Equatorial Guinea",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "GR": {
      "countryId": "GR",
      "displayValue": "Greece",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3} ?\\d{2}"
    },
    "GS": {
      "countryId": "GS",
      "displayValue": "South Georgia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "SIQQ 1ZZ"
    },
    "GT": {
      "countryId": "GT",
      "displayValue": "Guatemala",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}- {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "GU": {
      "countryId": "GU",
      "displayValue": "Guam",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?"
    },
    "GW": {
      "countryId": "GW",
      "displayValue": "Guinea-Bissau",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "GY": {
      "countryId": "GY",
      "displayValue": "Guyana",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "HK": {
      "countryId": "HK",
      "displayValue": "Hong Kong",
      "displayFormat": "{state}_{city}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "Area",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "Kowloon": {
          "stateValue": "Kowloon",
          "displayValue": "九龍"
        },
        "Hong Kong Island": {
          "stateValue": "Hong Kong Island",
          "displayValue": "香港島"
        },
        "New Territories": {
          "stateValue": "New Territories",
          "displayValue": "新界"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "HM": {
      "countryId": "HM",
      "displayValue": "Heard Island and McDonald Islands",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "HN": {
      "countryId": "HN",
      "displayValue": "Honduras",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Department",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "HR": {
      "countryId": "HR",
      "displayValue": "Croatia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_HR-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "HT": {
      "countryId": "HT",
      "displayValue": "Haiti",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_HT{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "HU": {
      "countryId": "HU",
      "displayValue": "Hungary",
      "displayFormat": "{firstName} {lastName}_{company}_{city}_{address1}_{address2}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "ID": {
      "countryId": "ID",
      "displayValue": "Indonesia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "AC": {
          "stateValue": "AC",
          "displayValue": "Aceh"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Bali"
        },
        "BT": {
          "stateValue": "BT",
          "displayValue": "Banten"
        },
        "BE": {
          "stateValue": "BE",
          "displayValue": "Bengkulu"
        },
        "YO": {
          "stateValue": "YO",
          "displayValue": "Special Region of Yogyakarta"
        },
        "JK": {
          "stateValue": "JK",
          "displayValue": "Jakarta"
        },
        "GO": {
          "stateValue": "GO",
          "displayValue": "Gorontalo"
        },
        "JA": {
          "stateValue": "JA",
          "displayValue": "Jambi"
        },
        "JB": {
          "stateValue": "JB",
          "displayValue": "West Java"
        },
        "JT": {
          "stateValue": "JT",
          "displayValue": "Central Java"
        },
        "JI": {
          "stateValue": "JI",
          "displayValue": "East Java"
        },
        "KB": {
          "stateValue": "KB",
          "displayValue": "West Kalimantan"
        },
        "KS": {
          "stateValue": "KS",
          "displayValue": "South Kalimantan"
        },
        "KT": {
          "stateValue": "KT",
          "displayValue": "Central Kalimantan"
        },
        "KI": {
          "stateValue": "KI",
          "displayValue": "East Kalimantan"
        },
        "KU": {
          "stateValue": "KU",
          "displayValue": "North Kalimantan"
        },
        "BB": {
          "stateValue": "BB",
          "displayValue": "Bangka Belitung Islands"
        },
        "KR": {
          "stateValue": "KR",
          "displayValue": "Riau Islands"
        },
        "LA": {
          "stateValue": "LA",
          "displayValue": "Lampung"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Maluku"
        },
        "MU": {
          "stateValue": "MU",
          "displayValue": "North Maluku"
        },
        "NB": {
          "stateValue": "NB",
          "displayValue": "West Nusa Tenggara"
        },
        "NT": {
          "stateValue": "NT",
          "displayValue": "East Nusa Tenggara"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "Papua"
        },
        "PB": {
          "stateValue": "PB",
          "displayValue": "West Papua"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Riau"
        },
        "SR": {
          "stateValue": "SR",
          "displayValue": "West Sulawesi"
        },
        "SN": {
          "stateValue": "SN",
          "displayValue": "South Sulawesi"
        },
        "ST": {
          "stateValue": "ST",
          "displayValue": "Central Sulawesi"
        },
        "SG": {
          "stateValue": "SG",
          "displayValue": "South East Sulawesi"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "North Sulawesi"
        },
        "SB": {
          "stateValue": "SB",
          "displayValue": "West Sumatra"
        },
        "SS": {
          "stateValue": "SS",
          "displayValue": "South Sumatra"
        },
        "SU": {
          "stateValue": "SU",
          "displayValue": "North Sumatra"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "IE": {
      "countryId": "IE",
      "displayValue": "Republic of Ireland",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city}_{state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "County",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "CW": {
          "stateValue": "CW",
          "displayValue": "Co. Carlow"
        },
        "CN": {
          "stateValue": "CN",
          "displayValue": "Co. Cavan"
        },
        "CE": {
          "stateValue": "CE",
          "displayValue": "Co. Clare"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Co. Cork"
        },
        "DL": {
          "stateValue": "DL",
          "displayValue": "Co. Donegal"
        },
        "D": {
          "stateValue": "D",
          "displayValue": "Co. Dublin"
        },
        "G": {
          "stateValue": "G",
          "displayValue": "Co. Galway"
        },
        "KY": {
          "stateValue": "KY",
          "displayValue": "Co. Kerry"
        },
        "KE": {
          "stateValue": "KE",
          "displayValue": "Co. Kildare"
        },
        "KK": {
          "stateValue": "KK",
          "displayValue": "Co. Kilkenny"
        },
        "LS": {
          "stateValue": "LS",
          "displayValue": "Co. Laois"
        },
        "LM": {
          "stateValue": "LM",
          "displayValue": "Co. Leitrim"
        },
        "LK": {
          "stateValue": "LK",
          "displayValue": "Co. Limerick"
        },
        "LD": {
          "stateValue": "LD",
          "displayValue": "Co. Longford"
        },
        "LH": {
          "stateValue": "LH",
          "displayValue": "Co. Louth"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Co. Mayo"
        },
        "MH": {
          "stateValue": "MH",
          "displayValue": "Co. Meath"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Co. Monaghan"
        },
        "OY": {
          "stateValue": "OY",
          "displayValue": "Co. Offaly"
        },
        "RN": {
          "stateValue": "RN",
          "displayValue": "Co. Roscommon"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Co. Sligo"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Co. Tipperary"
        },
        "WD": {
          "stateValue": "WD",
          "displayValue": "Co. Waterford"
        },
        "WH": {
          "stateValue": "WH",
          "displayValue": "Co. Westmeath"
        },
        "WX": {
          "stateValue": "WX",
          "displayValue": "Co. Wexford"
        },
        "WW": {
          "stateValue": "WW",
          "displayValue": "Co. Wicklow"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "[\\dA-Z]{3} ?[\\dA-Z]{4}"
    },
    "IL": {
      "countryId": "IL",
      "displayValue": "Israel",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}(?:\\d{2})?"
    },
    "IM": {
      "countryId": "IM",
      "displayValue": "Isle of Man",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}"
    },
    "IN": {
      "countryId": "IN",
      "displayValue": "India",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AN": {
          "stateValue": "AN",
          "displayValue": "Andaman & Nicobar"
        },
        "AP": {
          "stateValue": "AP",
          "displayValue": "Andhra Pradesh"
        },
        "AR": {
          "stateValue": "AR",
          "displayValue": "Arunachal Pradesh"
        },
        "AS": {
          "stateValue": "AS",
          "displayValue": "Assam"
        },
        "BR": {
          "stateValue": "BR",
          "displayValue": "Bihar"
        },
        "CH": {
          "stateValue": "CH",
          "displayValue": "Chandigarh"
        },
        "CT": {
          "stateValue": "CT",
          "displayValue": "Chhattisgarh"
        },
        "DH": {
          "stateValue": "DH",
          "displayValue": "Dadra & Nagar Haveli & Daman & Diu"
        },
        "DL": {
          "stateValue": "DL",
          "displayValue": "Delhi"
        },
        "GA": {
          "stateValue": "GA",
          "displayValue": "Goa"
        },
        "GJ": {
          "stateValue": "GJ",
          "displayValue": "Gujarat"
        },
        "HR": {
          "stateValue": "HR",
          "displayValue": "Haryana"
        },
        "HP": {
          "stateValue": "HP",
          "displayValue": "Himachal Pradesh"
        },
        "JK": {
          "stateValue": "JK",
          "displayValue": "Jammu & Kashmir"
        },
        "JH": {
          "stateValue": "JH",
          "displayValue": "Jharkhand"
        },
        "KA": {
          "stateValue": "KA",
          "displayValue": "Karnataka"
        },
        "KL": {
          "stateValue": "KL",
          "displayValue": "Kerala"
        },
        "LA": {
          "stateValue": "LA",
          "displayValue": "Ladakh"
        },
        "LD": {
          "stateValue": "LD",
          "displayValue": "Lakshadweep"
        },
        "MP": {
          "stateValue": "MP",
          "displayValue": "Madhya Pradesh"
        },
        "MH": {
          "stateValue": "MH",
          "displayValue": "Maharashtra"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Manipur"
        },
        "ML": {
          "stateValue": "ML",
          "displayValue": "Meghalaya"
        },
        "MZ": {
          "stateValue": "MZ",
          "displayValue": "Mizoram"
        },
        "NL": {
          "stateValue": "NL",
          "displayValue": "Nagaland"
        },
        "OR": {
          "stateValue": "OR",
          "displayValue": "Odisha"
        },
        "PY": {
          "stateValue": "PY",
          "displayValue": "Puducherry"
        },
        "PB": {
          "stateValue": "PB",
          "displayValue": "Punjab"
        },
        "RJ": {
          "stateValue": "RJ",
          "displayValue": "Rajasthan"
        },
        "SK": {
          "stateValue": "SK",
          "displayValue": "Sikkim"
        },
        "TN": {
          "stateValue": "TN",
          "displayValue": "Tamil Nadu"
        },
        "TG": {
          "stateValue": "TG",
          "displayValue": "Telangana"
        },
        "TR": {
          "stateValue": "TR",
          "displayValue": "Tripura"
        },
        "UP": {
          "stateValue": "UP",
          "displayValue": "Uttar Pradesh"
        },
        "UT": {
          "stateValue": "UT",
          "displayValue": "Uttarakhand"
        },
        "WB": {
          "stateValue": "WB",
          "displayValue": "West Bengal"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{6}"
    },
    "IO": {
      "countryId": "IO",
      "displayValue": "British Indian Ocean Territory",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "BBND 1ZZ"
    },
    "IQ": {
      "countryId": "IQ",
      "displayValue": "Iraq",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city}, {state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "IR": {
      "countryId": "IR",
      "displayValue": "Iran",
      "displayFormat": "{company}_{firstName} {lastName}_{state}_{city}, _{address1}_{address2}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Isfahan Province"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Sistan and Baluchestan Province"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Kurdistan Province"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Hamadan Province"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Chaharmahal and Bakhtiari Province"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Lorestan Province"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Ilam Province"
        },
        "17": {
          "stateValue": "17",
          "displayValue": "Kohgiluyeh and Boyer-Ahmad Province"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Bushehr Province"
        },
        "19": {
          "stateValue": "19",
          "displayValue": "Zanjan Province"
        },
        "20": {
          "stateValue": "20",
          "displayValue": "Semnan Province"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Yazd Province"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Hormozgan Province"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Tehran Province"
        },
        "24": {
          "stateValue": "24",
          "displayValue": "Ardabil Province"
        },
        "25": {
          "stateValue": "25",
          "displayValue": "Qom Province"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Qazvin Province"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Golestan Province"
        },
        "28": {
          "stateValue": "28",
          "displayValue": "North Khorasan Province"
        },
        "29": {
          "stateValue": "29",
          "displayValue": "South Khorasan Province"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Alborz Province"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "East Azerbaijan Province"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "West Azerbaijan Province"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Razavi Khorasan Province"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Khuzestan Province"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Fars Province"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Kerman Province"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Kermanshah Province"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Gilan Province"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Mazandaran Province"
        },
        "00": {
          "stateValue": "00",
          "displayValue": "Markazi Province"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}-?\\d{5}"
    },
    "IS": {
      "countryId": "IS",
      "displayValue": "Iceland",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "IT": {
      "countryId": "IT",
      "displayValue": "Italy",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AG": {
          "stateValue": "AG",
          "displayValue": "Agrigento"
        },
        "AL": {
          "stateValue": "AL",
          "displayValue": "Alessandria"
        },
        "AN": {
          "stateValue": "AN",
          "displayValue": "Ancona"
        },
        "AO": {
          "stateValue": "AO",
          "displayValue": "Aosta"
        },
        "AR": {
          "stateValue": "AR",
          "displayValue": "Arezzo"
        },
        "AP": {
          "stateValue": "AP",
          "displayValue": "Ascoli Piceno"
        },
        "AT": {
          "stateValue": "AT",
          "displayValue": "Asti"
        },
        "AV": {
          "stateValue": "AV",
          "displayValue": "Avellino"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Bari"
        },
        "BT": {
          "stateValue": "BT",
          "displayValue": "Barletta-Andria-Trani"
        },
        "BL": {
          "stateValue": "BL",
          "displayValue": "Belluno"
        },
        "BN": {
          "stateValue": "BN",
          "displayValue": "Benevento"
        },
        "BG": {
          "stateValue": "BG",
          "displayValue": "Bergamo"
        },
        "BI": {
          "stateValue": "BI",
          "displayValue": "Biella"
        },
        "BO": {
          "stateValue": "BO",
          "displayValue": "Bologna"
        },
        "BZ": {
          "stateValue": "BZ",
          "displayValue": "Bolzano"
        },
        "BS": {
          "stateValue": "BS",
          "displayValue": "Brescia"
        },
        "BR": {
          "stateValue": "BR",
          "displayValue": "Brindisi"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "Cagliari"
        },
        "CL": {
          "stateValue": "CL",
          "displayValue": "Caltanissetta"
        },
        "CB": {
          "stateValue": "CB",
          "displayValue": "Campobasso"
        },
        "CE": {
          "stateValue": "CE",
          "displayValue": "Caserta"
        },
        "CT": {
          "stateValue": "CT",
          "displayValue": "Catania"
        },
        "CZ": {
          "stateValue": "CZ",
          "displayValue": "Catanzaro"
        },
        "CH": {
          "stateValue": "CH",
          "displayValue": "Chieti"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Como"
        },
        "CS": {
          "stateValue": "CS",
          "displayValue": "Cosenza"
        },
        "CR": {
          "stateValue": "CR",
          "displayValue": "Cremona"
        },
        "KR": {
          "stateValue": "KR",
          "displayValue": "Crotone"
        },
        "CN": {
          "stateValue": "CN",
          "displayValue": "Cuneo"
        },
        "EN": {
          "stateValue": "EN",
          "displayValue": "Enna"
        },
        "FM": {
          "stateValue": "FM",
          "displayValue": "Fermo"
        },
        "FE": {
          "stateValue": "FE",
          "displayValue": "Ferrara"
        },
        "FI": {
          "stateValue": "FI",
          "displayValue": "Firenze"
        },
        "FG": {
          "stateValue": "FG",
          "displayValue": "Foggia"
        },
        "FC": {
          "stateValue": "FC",
          "displayValue": "Forlì-Cesena"
        },
        "FR": {
          "stateValue": "FR",
          "displayValue": "Frosinone"
        },
        "GE": {
          "stateValue": "GE",
          "displayValue": "Genova"
        },
        "GO": {
          "stateValue": "GO",
          "displayValue": "Gorizia"
        },
        "GR": {
          "stateValue": "GR",
          "displayValue": "Grosseto"
        },
        "IM": {
          "stateValue": "IM",
          "displayValue": "Imperia"
        },
        "IS": {
          "stateValue": "IS",
          "displayValue": "Isernia"
        },
        "AQ": {
          "stateValue": "AQ",
          "displayValue": "L'Aquila"
        },
        "SP": {
          "stateValue": "SP",
          "displayValue": "La Spezia"
        },
        "LT": {
          "stateValue": "LT",
          "displayValue": "Latina"
        },
        "LE": {
          "stateValue": "LE",
          "displayValue": "Lecce"
        },
        "LC": {
          "stateValue": "LC",
          "displayValue": "Lecco"
        },
        "LI": {
          "stateValue": "LI",
          "displayValue": "Livorno"
        },
        "LO": {
          "stateValue": "LO",
          "displayValue": "Lodi"
        },
        "LU": {
          "stateValue": "LU",
          "displayValue": "Lucca"
        },
        "MC": {
          "stateValue": "MC",
          "displayValue": "Macerata"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Mantova"
        },
        "MS": {
          "stateValue": "MS",
          "displayValue": "Massa-Carrara"
        },
        "MT": {
          "stateValue": "MT",
          "displayValue": "Matera"
        },
        "ME": {
          "stateValue": "ME",
          "displayValue": "Messina"
        },
        "MI": {
          "stateValue": "MI",
          "displayValue": "Milano"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Modena"
        },
        "MB": {
          "stateValue": "MB",
          "displayValue": "Monza e Brianza"
        },
        "NA": {
          "stateValue": "NA",
          "displayValue": "Napoli"
        },
        "NO": {
          "stateValue": "NO",
          "displayValue": "Novara"
        },
        "NU": {
          "stateValue": "NU",
          "displayValue": "Nuoro"
        },
        "OR": {
          "stateValue": "OR",
          "displayValue": "Oristano"
        },
        "PD": {
          "stateValue": "PD",
          "displayValue": "Padova"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "Palermo"
        },
        "PR": {
          "stateValue": "PR",
          "displayValue": "Parma"
        },
        "PV": {
          "stateValue": "PV",
          "displayValue": "Pavia"
        },
        "PG": {
          "stateValue": "PG",
          "displayValue": "Perugia"
        },
        "PU": {
          "stateValue": "PU",
          "displayValue": "Pesaro e Urbino"
        },
        "PE": {
          "stateValue": "PE",
          "displayValue": "Pescara"
        },
        "PC": {
          "stateValue": "PC",
          "displayValue": "Piacenza"
        },
        "PI": {
          "stateValue": "PI",
          "displayValue": "Pisa"
        },
        "PT": {
          "stateValue": "PT",
          "displayValue": "Pistoia"
        },
        "PN": {
          "stateValue": "PN",
          "displayValue": "Pordenone"
        },
        "PZ": {
          "stateValue": "PZ",
          "displayValue": "Potenza"
        },
        "PO": {
          "stateValue": "PO",
          "displayValue": "Prato"
        },
        "RG": {
          "stateValue": "RG",
          "displayValue": "Ragusa"
        },
        "RA": {
          "stateValue": "RA",
          "displayValue": "Ravenna"
        },
        "RC": {
          "stateValue": "RC",
          "displayValue": "Reggio Calabria"
        },
        "RE": {
          "stateValue": "RE",
          "displayValue": "Reggio Emilia"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Rieti"
        },
        "RN": {
          "stateValue": "RN",
          "displayValue": "Rimini"
        },
        "RM": {
          "stateValue": "RM",
          "displayValue": "Roma"
        },
        "RO": {
          "stateValue": "RO",
          "displayValue": "Rovigo"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Salerno"
        },
        "SS": {
          "stateValue": "SS",
          "displayValue": "Sassari"
        },
        "SV": {
          "stateValue": "SV",
          "displayValue": "Savona"
        },
        "SI": {
          "stateValue": "SI",
          "displayValue": "Siena"
        },
        "SR": {
          "stateValue": "SR",
          "displayValue": "Siracusa"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Sondrio"
        },
        "SU": {
          "stateValue": "SU",
          "displayValue": "Sud Sardegna"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Taranto"
        },
        "TE": {
          "stateValue": "TE",
          "displayValue": "Teramo"
        },
        "TR": {
          "stateValue": "TR",
          "displayValue": "Terni"
        },
        "TO": {
          "stateValue": "TO",
          "displayValue": "Torino"
        },
        "TP": {
          "stateValue": "TP",
          "displayValue": "Trapani"
        },
        "TN": {
          "stateValue": "TN",
          "displayValue": "Trento"
        },
        "TV": {
          "stateValue": "TV",
          "displayValue": "Treviso"
        },
        "TS": {
          "stateValue": "TS",
          "displayValue": "Trieste"
        },
        "UD": {
          "stateValue": "UD",
          "displayValue": "Udine"
        },
        "VA": {
          "stateValue": "VA",
          "displayValue": "Varese"
        },
        "VE": {
          "stateValue": "VE",
          "displayValue": "Venezia"
        },
        "VB": {
          "stateValue": "VB",
          "displayValue": "Verbano-Cusio-Ossola"
        },
        "VC": {
          "stateValue": "VC",
          "displayValue": "Vercelli"
        },
        "VR": {
          "stateValue": "VR",
          "displayValue": "Verona"
        },
        "VV": {
          "stateValue": "VV",
          "displayValue": "Vibo Valentia"
        },
        "VI": {
          "stateValue": "VI",
          "displayValue": "Vicenza"
        },
        "VT": {
          "stateValue": "VT",
          "displayValue": "Viterbo"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "JE": {
      "countryId": "JE",
      "displayValue": "Jersey",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_JERSEY_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}"
    },
    "JM": {
      "countryId": "JM",
      "displayValue": "Jamaica",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Parish",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Westmoreland"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "St. Elizabeth"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Manchester"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Clarendon"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "St. Catherine"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Hanover"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Kingston"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Portland"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "St. Andrew"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "St. Ann"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "St. James"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "St. Mary"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "St. Thomas"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Trelawny"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "JO": {
      "countryId": "JO",
      "displayValue": "Jordan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "JP": {
      "countryId": "JP",
      "displayValue": "Japan",
      "displayFormat": "〒{zip}_{state}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Prefecture",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Gunma"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Saitama"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Chiba"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Tokyo"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Kanagawa"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Niigata"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Toyama"
        },
        "17": {
          "stateValue": "17",
          "displayValue": "Ishikawa"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Fukui"
        },
        "19": {
          "stateValue": "19",
          "displayValue": "Yamanashi"
        },
        "20": {
          "stateValue": "20",
          "displayValue": "Nagano"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Gifu"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Shizuoka"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Aichi"
        },
        "24": {
          "stateValue": "24",
          "displayValue": "Mie"
        },
        "25": {
          "stateValue": "25",
          "displayValue": "Shiga"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Kyoto"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Osaka"
        },
        "28": {
          "stateValue": "28",
          "displayValue": "Hyogo"
        },
        "29": {
          "stateValue": "29",
          "displayValue": "Nara"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Wakayama"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Tottori"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Shimane"
        },
        "33": {
          "stateValue": "33",
          "displayValue": "Okayama"
        },
        "34": {
          "stateValue": "34",
          "displayValue": "Hiroshima"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "Yamaguchi"
        },
        "36": {
          "stateValue": "36",
          "displayValue": "Tokushima"
        },
        "37": {
          "stateValue": "37",
          "displayValue": "Kagawa"
        },
        "38": {
          "stateValue": "38",
          "displayValue": "Ehime"
        },
        "39": {
          "stateValue": "39",
          "displayValue": "Kochi"
        },
        "40": {
          "stateValue": "40",
          "displayValue": "Fukuoka"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Saga"
        },
        "42": {
          "stateValue": "42",
          "displayValue": "Nagasaki"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Kumamoto"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "Oita"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Miyazaki"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Kagoshima"
        },
        "47": {
          "stateValue": "47",
          "displayValue": "Okinawa"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Hokkaido"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Aomori"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Iwate"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Miyagi"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Akita"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Yamagata"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Fukushima"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Ibaraki"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Tochigi"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3}-?\\d{4}"
    },
    "KE": {
      "countryId": "KE",
      "displayValue": "Kenya",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "KG": {
      "countryId": "KG",
      "displayValue": "Kyrgyzstan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "KH": {
      "countryId": "KH",
      "displayValue": "Cambodia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5,6}"
    },
    "KI": {
      "countryId": "KI",
      "displayValue": "Kiribati",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "KM": {
      "countryId": "KM",
      "displayValue": "Comoros",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "KN": {
      "countryId": "KN",
      "displayValue": "Saint Kitts and Nevis",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "N": {
          "stateValue": "N",
          "displayValue": "Nevis"
        },
        "K": {
          "stateValue": "K",
          "displayValue": "St. Kitts"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "KP": {
      "countryId": "KP",
      "displayValue": "North Korea",
      "displayFormat": "{zip}_{state}_{city}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Ryanggang"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Rason"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Kangwon"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Chagang"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "South Pyongan"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "North Pyongan"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Pyongyang"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "South Hamgyong"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "North Hamgyong"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "South Hwanghae"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "North Hwanghae"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "KR": {
      "countryId": "KR",
      "displayValue": "South Korea",
      "displayFormat": "{state} {city}_{address1}_{address2}_{company}_{firstName} {lastName}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Do_si",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "11": {
          "stateValue": "11",
          "displayValue": "Seoul"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Busan"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Daegu"
        },
        "28": {
          "stateValue": "28",
          "displayValue": "Incheon"
        },
        "29": {
          "stateValue": "29",
          "displayValue": "Gwangju"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Daejeon"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Ulsan"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Gyeonggi-do"
        },
        "42": {
          "stateValue": "42",
          "displayValue": "Gangwon-do"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Chungcheongbuk-do"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "Chungcheongnam-do"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Jeollabuk-do"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Jeollanam-do"
        },
        "47": {
          "stateValue": "47",
          "displayValue": "Gyeongsangbuk-do"
        },
        "48": {
          "stateValue": "48",
          "displayValue": "Gyeongsangnam-do"
        },
        "49": {
          "stateValue": "49",
          "displayValue": "Jeju-do"
        },
        "50": {
          "stateValue": "50",
          "displayValue": "Sejong"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "KW": {
      "countryId": "KW",
      "displayValue": "Kuwait",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "KY": {
      "countryId": "KY",
      "displayValue": "Cayman Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "Cayman Brac": {
          "stateValue": "Cayman Brac",
          "displayValue": "Cayman Brac"
        },
        "Grand Cayman": {
          "stateValue": "Grand Cayman",
          "displayValue": "Grand Cayman"
        },
        "Little Cayman": {
          "stateValue": "Little Cayman",
          "displayValue": "Little Cayman"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "KY\\d-\\d{4}"
    },
    "KZ": {
      "countryId": "KZ",
      "displayValue": "Kazakhstan",
      "displayFormat": "{zip}_{state}_{city}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "LA": {
      "countryId": "LA",
      "displayValue": "Laos",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "LB": {
      "countryId": "LB",
      "displayValue": "Lebanon",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:\\d{4})(?: ?(?:\\d{4}))?"
    },
    "LC": {
      "countryId": "LC",
      "displayValue": "Saint Lucia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "LI": {
      "countryId": "LI",
      "displayValue": "Liechtenstein",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_FL-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "948[5-9]|949[0-8]"
    },
    "LK": {
      "countryId": "LK",
      "displayValue": "Sri Lanka",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "LR": {
      "countryId": "LR",
      "displayValue": "Liberia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "LS": {
      "countryId": "LS",
      "displayValue": "Lesotho",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "LT": {
      "countryId": "LT",
      "displayValue": "Lithuania",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_LT-{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "LU": {
      "countryId": "LU",
      "displayValue": "Luxembourg",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_L-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "LV": {
      "countryId": "LV",
      "displayValue": "Latvia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state}_{city}, {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "LV-\\d{4}"
    },
    "LY": {
      "countryId": "LY",
      "displayValue": "Libya",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MA": {
      "countryId": "MA",
      "displayValue": "Morocco",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "MC": {
      "countryId": "MC",
      "displayValue": "Monaco",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_MC-{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "980\\d{2}"
    },
    "MD": {
      "countryId": "MD",
      "displayValue": "Moldova",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_MD-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "ME": {
      "countryId": "ME",
      "displayValue": "Montenegro",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "8\\d{4}"
    },
    "MF": {
      "countryId": "MF",
      "displayValue": "Saint Martin",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78][01]\\d{2}"
    },
    "MG": {
      "countryId": "MG",
      "displayValue": "Madagascar",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "MH": {
      "countryId": "MH",
      "displayValue": "Marshall Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(969[67]\\d)(?:[ \\-](\\d{4}))?"
    },
    "MK": {
      "countryId": "MK",
      "displayValue": "Republic of Macedonia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "ML": {
      "countryId": "ML",
      "displayValue": "Mali",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MM": {
      "countryId": "MM",
      "displayValue": "Myanmar",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "MN": {
      "countryId": "MN",
      "displayValue": "Mongolia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "MO": {
      "countryId": "MO",
      "displayValue": "Macau",
      "displayFormat": "{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MP": {
      "countryId": "MP",
      "displayValue": "Northern Mariana Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(9695[012])(?:[ \\-](\\d{4}))?"
    },
    "MQ": {
      "countryId": "MQ",
      "displayValue": "Martinique",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78]2\\d{2}"
    },
    "MR": {
      "countryId": "MR",
      "displayValue": "Mauritania",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MS": {
      "countryId": "MS",
      "displayValue": "Montserrat",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MT": {
      "countryId": "MT",
      "displayValue": "Malta",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "[A-Z]{3} ?\\d{2,4}"
    },
    "MU": {
      "countryId": "MU",
      "displayValue": "Mauritius",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})"
    },
    "MV": {
      "countryId": "MV",
      "displayValue": "Maldives",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "MW": {
      "countryId": "MW",
      "displayValue": "Malawi",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "MX": {
      "countryId": "MX",
      "displayValue": "Mexico",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{zip} {city}, {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AGU": {
          "stateValue": "AGU",
          "displayValue": "Aguascalientes"
        },
        "BCN": {
          "stateValue": "BCN",
          "displayValue": "Baja California"
        },
        "BCS": {
          "stateValue": "BCS",
          "displayValue": "Baja California Sur"
        },
        "CAM": {
          "stateValue": "CAM",
          "displayValue": "Campeche"
        },
        "CHP": {
          "stateValue": "CHP",
          "displayValue": "Chiapas"
        },
        "CHH": {
          "stateValue": "CHH",
          "displayValue": "Chihuahua"
        },
        "CMX": {
          "stateValue": "CMX",
          "displayValue": "Ciudad de México"
        },
        "COA": {
          "stateValue": "COA",
          "displayValue": "Coahuila de Zaragoza"
        },
        "COL": {
          "stateValue": "COL",
          "displayValue": "Colima"
        },
        "DUR": {
          "stateValue": "DUR",
          "displayValue": "Durango"
        },
        "MEX": {
          "stateValue": "MEX",
          "displayValue": "Estado de México"
        },
        "GUA": {
          "stateValue": "GUA",
          "displayValue": "Guanajuato"
        },
        "GRO": {
          "stateValue": "GRO",
          "displayValue": "Guerrero"
        },
        "HID": {
          "stateValue": "HID",
          "displayValue": "Hidalgo"
        },
        "JAL": {
          "stateValue": "JAL",
          "displayValue": "Jalisco"
        },
        "MIC": {
          "stateValue": "MIC",
          "displayValue": "Michoacán"
        },
        "MOR": {
          "stateValue": "MOR",
          "displayValue": "Morelos"
        },
        "NAY": {
          "stateValue": "NAY",
          "displayValue": "Nayarit"
        },
        "NLE": {
          "stateValue": "NLE",
          "displayValue": "Nuevo León"
        },
        "OAX": {
          "stateValue": "OAX",
          "displayValue": "Oaxaca"
        },
        "PUE": {
          "stateValue": "PUE",
          "displayValue": "Puebla"
        },
        "QUE": {
          "stateValue": "QUE",
          "displayValue": "Querétaro"
        },
        "ROO": {
          "stateValue": "ROO",
          "displayValue": "Quintana Roo"
        },
        "SLP": {
          "stateValue": "SLP",
          "displayValue": "San Luis Potosí"
        },
        "SIN": {
          "stateValue": "SIN",
          "displayValue": "Sinaloa"
        },
        "SON": {
          "stateValue": "SON",
          "displayValue": "Sonora"
        },
        "TAB": {
          "stateValue": "TAB",
          "displayValue": "Tabasco"
        },
        "TAM": {
          "stateValue": "TAM",
          "displayValue": "Tamaulipas"
        },
        "TLA": {
          "stateValue": "TLA",
          "displayValue": "Tlaxcala"
        },
        "VER": {
          "stateValue": "VER",
          "displayValue": "Veracruz"
        },
        "YUC": {
          "stateValue": "YUC",
          "displayValue": "Yucatán"
        },
        "ZAC": {
          "stateValue": "ZAC",
          "displayValue": "Zacatecas"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "MY": {
      "countryId": "MY",
      "displayValue": "Malaysia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{zip} {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Selangor"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Terengganu"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Sabah"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Sarawak"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Kuala Lumpur"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Labuan"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Putrajaya"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Johor"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Kedah"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Kelantan"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Melaka"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Negeri Sembilan"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Pahang"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Perak"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Perlis"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Pulau Pinang"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "MZ": {
      "countryId": "MZ",
      "displayValue": "Mozambique",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "P": {
          "stateValue": "P",
          "displayValue": "Cabo Delgado"
        },
        "MPM": {
          "stateValue": "MPM",
          "displayValue": "Cidade de Maputo"
        },
        "G": {
          "stateValue": "G",
          "displayValue": "Gaza"
        },
        "I": {
          "stateValue": "I",
          "displayValue": "Inhambane"
        },
        "B": {
          "stateValue": "B",
          "displayValue": "Manica"
        },
        "L": {
          "stateValue": "L",
          "displayValue": "Maputo"
        },
        "N": {
          "stateValue": "N",
          "displayValue": "Nampula"
        },
        "A": {
          "stateValue": "A",
          "displayValue": "Niassa"
        },
        "S": {
          "stateValue": "S",
          "displayValue": "Sofala"
        },
        "T": {
          "stateValue": "T",
          "displayValue": "Tete"
        },
        "Q": {
          "stateValue": "Q",
          "displayValue": "Zambezia"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "NA": {
      "countryId": "NA",
      "displayValue": "Namibia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "NC": {
      "countryId": "NC",
      "displayValue": "New Caledonia",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "988\\d{2}"
    },
    "NE": {
      "countryId": "NE",
      "displayValue": "Niger",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "NF": {
      "countryId": "NF",
      "displayValue": "Norfolk Island",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "2899"
    },
    "NG": {
      "countryId": "NG",
      "displayValue": "Nigeria",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city} {zip}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "AB": {
          "stateValue": "AB",
          "displayValue": "Abia"
        },
        "AD": {
          "stateValue": "AD",
          "displayValue": "Adamawa"
        },
        "AK": {
          "stateValue": "AK",
          "displayValue": "Akwa Ibom"
        },
        "AN": {
          "stateValue": "AN",
          "displayValue": "Anambra"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Bauchi"
        },
        "BY": {
          "stateValue": "BY",
          "displayValue": "Bayelsa"
        },
        "BE": {
          "stateValue": "BE",
          "displayValue": "Benue"
        },
        "BO": {
          "stateValue": "BO",
          "displayValue": "Borno"
        },
        "CR": {
          "stateValue": "CR",
          "displayValue": "Cross River"
        },
        "DE": {
          "stateValue": "DE",
          "displayValue": "Delta"
        },
        "EB": {
          "stateValue": "EB",
          "displayValue": "Ebonyi"
        },
        "ED": {
          "stateValue": "ED",
          "displayValue": "Edo"
        },
        "EK": {
          "stateValue": "EK",
          "displayValue": "Ekiti"
        },
        "EN": {
          "stateValue": "EN",
          "displayValue": "Enugu"
        },
        "FC": {
          "stateValue": "FC",
          "displayValue": "Federal Capital Territory"
        },
        "GO": {
          "stateValue": "GO",
          "displayValue": "Gombe"
        },
        "IM": {
          "stateValue": "IM",
          "displayValue": "Imo"
        },
        "JI": {
          "stateValue": "JI",
          "displayValue": "Jigawa"
        },
        "KD": {
          "stateValue": "KD",
          "displayValue": "Kaduna"
        },
        "KN": {
          "stateValue": "KN",
          "displayValue": "Kano"
        },
        "KT": {
          "stateValue": "KT",
          "displayValue": "Katsina"
        },
        "KE": {
          "stateValue": "KE",
          "displayValue": "Kebbi"
        },
        "KO": {
          "stateValue": "KO",
          "displayValue": "Kogi"
        },
        "KW": {
          "stateValue": "KW",
          "displayValue": "Kwara"
        },
        "LA": {
          "stateValue": "LA",
          "displayValue": "Lagos"
        },
        "NA": {
          "stateValue": "NA",
          "displayValue": "Nasarawa"
        },
        "NI": {
          "stateValue": "NI",
          "displayValue": "Niger"
        },
        "OG": {
          "stateValue": "OG",
          "displayValue": "Ogun State"
        },
        "ON": {
          "stateValue": "ON",
          "displayValue": "Ondo"
        },
        "OS": {
          "stateValue": "OS",
          "displayValue": "Osun"
        },
        "OY": {
          "stateValue": "OY",
          "displayValue": "Oyo"
        },
        "PL": {
          "stateValue": "PL",
          "displayValue": "Plateau"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Rivers"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Sokoto"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Taraba"
        },
        "YO": {
          "stateValue": "YO",
          "displayValue": "Yobe"
        },
        "ZA": {
          "stateValue": "ZA",
          "displayValue": "Zamfara"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "NI": {
      "countryId": "NI",
      "displayValue": "Nicaragua",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}, {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Department",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "BO": {
          "stateValue": "BO",
          "displayValue": "Boaco"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "Carazo"
        },
        "CI": {
          "stateValue": "CI",
          "displayValue": "Chinandega"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Chontales"
        },
        "ES": {
          "stateValue": "ES",
          "displayValue": "Estelí"
        },
        "GR": {
          "stateValue": "GR",
          "displayValue": "Granada"
        },
        "JI": {
          "stateValue": "JI",
          "displayValue": "Jinotega"
        },
        "LE": {
          "stateValue": "LE",
          "displayValue": "León"
        },
        "MD": {
          "stateValue": "MD",
          "displayValue": "Madriz"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Managua"
        },
        "MS": {
          "stateValue": "MS",
          "displayValue": "Masaya"
        },
        "MT": {
          "stateValue": "MT",
          "displayValue": "Matagalpa"
        },
        "NS": {
          "stateValue": "NS",
          "displayValue": "Nueva Segovia"
        },
        "AN": {
          "stateValue": "AN",
          "displayValue": "Región Autónoma de la Costa Caribe Norte"
        },
        "AS": {
          "stateValue": "AS",
          "displayValue": "Región Autónoma de la Costa Caribe Sur"
        },
        "SJ": {
          "stateValue": "SJ",
          "displayValue": "Río San Juan"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Rivas"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "NL": {
      "countryId": "NL",
      "displayValue": "Netherlands",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "[1-9]\\d{3} ?(?:[A-RT-Z][A-Z]|S[BCE-RT-Z])"
    },
    "NO": {
      "countryId": "NO",
      "displayValue": "Norway",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "Post town",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "NP": {
      "countryId": "NP",
      "displayValue": "Nepal",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "NR": {
      "countryId": "NR",
      "displayValue": "Nauru",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "District",
      "stateRequired": true,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Ijuw District"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Meneng District"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Nibok District"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Uaboe District"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Yaren District"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Aiwo District"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Anabar District"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Anetan District"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Anibare District"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Baiti District"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Boe District"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Buada District"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Denigomodu District"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Ewa District"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "NU": {
      "countryId": "NU",
      "displayValue": "Niue",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "NZ": {
      "countryId": "NZ",
      "displayValue": "New Zealand",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "OM": {
      "countryId": "OM",
      "displayValue": "Oman",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:PC )?\\d{3}"
    },
    "PA": {
      "countryId": "PA",
      "displayValue": "Panama",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "PE": {
      "countryId": "PE",
      "displayValue": "Peru",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{state}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "AMA": {
          "stateValue": "AMA",
          "displayValue": "Amazonas"
        },
        "ANC": {
          "stateValue": "ANC",
          "displayValue": "Áncash"
        },
        "APU": {
          "stateValue": "APU",
          "displayValue": "Apurímac"
        },
        "ARE": {
          "stateValue": "ARE",
          "displayValue": "Arequipa"
        },
        "AYA": {
          "stateValue": "AYA",
          "displayValue": "Ayacucho"
        },
        "CAJ": {
          "stateValue": "CAJ",
          "displayValue": "Cajamarca"
        },
        "CAL": {
          "stateValue": "CAL",
          "displayValue": "Callao"
        },
        "CUS": {
          "stateValue": "CUS",
          "displayValue": "Cuzco"
        },
        "LIM": {
          "stateValue": "LIM",
          "displayValue": "Gobierno Regional de Lima"
        },
        "HUV": {
          "stateValue": "HUV",
          "displayValue": "Huancavelica"
        },
        "HUC": {
          "stateValue": "HUC",
          "displayValue": "Huánuco"
        },
        "ICA": {
          "stateValue": "ICA",
          "displayValue": "Ica"
        },
        "JUN": {
          "stateValue": "JUN",
          "displayValue": "Junín"
        },
        "LAL": {
          "stateValue": "LAL",
          "displayValue": "La Libertad"
        },
        "LAM": {
          "stateValue": "LAM",
          "displayValue": "Lambayeque"
        },
        "LOR": {
          "stateValue": "LOR",
          "displayValue": "Loreto"
        },
        "MDD": {
          "stateValue": "MDD",
          "displayValue": "Madre de Dios"
        },
        "MOQ": {
          "stateValue": "MOQ",
          "displayValue": "Moquegua"
        },
        "LMA": {
          "stateValue": "LMA",
          "displayValue": "Municipalidad Metropolitana de Lima"
        },
        "PAS": {
          "stateValue": "PAS",
          "displayValue": "Pasco"
        },
        "PIU": {
          "stateValue": "PIU",
          "displayValue": "Piura"
        },
        "PUN": {
          "stateValue": "PUN",
          "displayValue": "Puno"
        },
        "SAM": {
          "stateValue": "SAM",
          "displayValue": "San Martín"
        },
        "TAC": {
          "stateValue": "TAC",
          "displayValue": "Tacna"
        },
        "TUM": {
          "stateValue": "TUM",
          "displayValue": "Tumbes"
        },
        "UCA": {
          "stateValue": "UCA",
          "displayValue": "Ucayali"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}"
    },
    "PF": {
      "countryId": "PF",
      "displayValue": "French Polynesia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "987\\d{2}"
    },
    "PG": {
      "countryId": "PG",
      "displayValue": "Papua New Guinea",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{3}"
    },
    "PH": {
      "countryId": "PH",
      "displayValue": "Philippines",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_, {city}_{zip} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "ABR": {
          "stateValue": "ABR",
          "displayValue": "Abra"
        },
        "AGN": {
          "stateValue": "AGN",
          "displayValue": "Agusan del Norte"
        },
        "AGS": {
          "stateValue": "AGS",
          "displayValue": "Agusan del Sur"
        },
        "AKL": {
          "stateValue": "AKL",
          "displayValue": "Aklan"
        },
        "ALB": {
          "stateValue": "ALB",
          "displayValue": "Albay"
        },
        "ANT": {
          "stateValue": "ANT",
          "displayValue": "Antique"
        },
        "APA": {
          "stateValue": "APA",
          "displayValue": "Apayao"
        },
        "AUR": {
          "stateValue": "AUR",
          "displayValue": "Aurora"
        },
        "BAS": {
          "stateValue": "BAS",
          "displayValue": "Basilan"
        },
        "BAN": {
          "stateValue": "BAN",
          "displayValue": "Bataan"
        },
        "BTN": {
          "stateValue": "BTN",
          "displayValue": "Batanes"
        },
        "BTG": {
          "stateValue": "BTG",
          "displayValue": "Batangas"
        },
        "BEN": {
          "stateValue": "BEN",
          "displayValue": "Benguet"
        },
        "BIL": {
          "stateValue": "BIL",
          "displayValue": "Biliran"
        },
        "BOH": {
          "stateValue": "BOH",
          "displayValue": "Bohol"
        },
        "BUK": {
          "stateValue": "BUK",
          "displayValue": "Bukidnon"
        },
        "BUL": {
          "stateValue": "BUL",
          "displayValue": "Bulacan"
        },
        "CAG": {
          "stateValue": "CAG",
          "displayValue": "Cagayan"
        },
        "CAN": {
          "stateValue": "CAN",
          "displayValue": "Camarines Norte"
        },
        "CAS": {
          "stateValue": "CAS",
          "displayValue": "Camarines Sur"
        },
        "CAM": {
          "stateValue": "CAM",
          "displayValue": "Camiguin"
        },
        "CAP": {
          "stateValue": "CAP",
          "displayValue": "Capiz"
        },
        "CAT": {
          "stateValue": "CAT",
          "displayValue": "Catanduanes"
        },
        "CAV": {
          "stateValue": "CAV",
          "displayValue": "Cavite"
        },
        "CEB": {
          "stateValue": "CEB",
          "displayValue": "Cebu"
        },
        "COM": {
          "stateValue": "COM",
          "displayValue": "Compostela Valley"
        },
        "NCO": {
          "stateValue": "NCO",
          "displayValue": "Cotabato"
        },
        "DAV": {
          "stateValue": "DAV",
          "displayValue": "Davao del Norte"
        },
        "DAS": {
          "stateValue": "DAS",
          "displayValue": "Davao del Sur"
        },
        "DVO": {
          "stateValue": "DVO",
          "displayValue": "Davao Occidental"
        },
        "DAO": {
          "stateValue": "DAO",
          "displayValue": "Davao Oriental"
        },
        "DIN": {
          "stateValue": "DIN",
          "displayValue": "Dinagat Islands"
        },
        "EAS": {
          "stateValue": "EAS",
          "displayValue": "Eastern Samar"
        },
        "GUI": {
          "stateValue": "GUI",
          "displayValue": "Guimaras"
        },
        "IFU": {
          "stateValue": "IFU",
          "displayValue": "Ifugao"
        },
        "ILN": {
          "stateValue": "ILN",
          "displayValue": "Ilocos Norte"
        },
        "ILS": {
          "stateValue": "ILS",
          "displayValue": "Ilocos Sur"
        },
        "ILI": {
          "stateValue": "ILI",
          "displayValue": "Iloilo"
        },
        "ISA": {
          "stateValue": "ISA",
          "displayValue": "Isabela"
        },
        "KAL": {
          "stateValue": "KAL",
          "displayValue": "Kalinga"
        },
        "LUN": {
          "stateValue": "LUN",
          "displayValue": "La Union"
        },
        "LAG": {
          "stateValue": "LAG",
          "displayValue": "Laguna"
        },
        "LAN": {
          "stateValue": "LAN",
          "displayValue": "Lanao del Norte"
        },
        "LAS": {
          "stateValue": "LAS",
          "displayValue": "Lanao del Sur"
        },
        "LEY": {
          "stateValue": "LEY",
          "displayValue": "Leyte"
        },
        "MAG": {
          "stateValue": "MAG",
          "displayValue": "Maguindanao"
        },
        "MAD": {
          "stateValue": "MAD",
          "displayValue": "Marinduque"
        },
        "MAS": {
          "stateValue": "MAS",
          "displayValue": "Masbate"
        },
        "00": {
          "stateValue": "00",
          "displayValue": "Metro Manila"
        },
        "MDC": {
          "stateValue": "MDC",
          "displayValue": "Mindoro Occidental"
        },
        "MDR": {
          "stateValue": "MDR",
          "displayValue": "Mindoro Oriental"
        },
        "MSC": {
          "stateValue": "MSC",
          "displayValue": "Misamis Occidental"
        },
        "MSR": {
          "stateValue": "MSR",
          "displayValue": "Misamis Oriental"
        },
        "MOU": {
          "stateValue": "MOU",
          "displayValue": "Mountain Province"
        },
        "NEC": {
          "stateValue": "NEC",
          "displayValue": "Negros Occidental"
        },
        "NER": {
          "stateValue": "NER",
          "displayValue": "Negros Oriental"
        },
        "NSA": {
          "stateValue": "NSA",
          "displayValue": "Northern Samar"
        },
        "NUE": {
          "stateValue": "NUE",
          "displayValue": "Nueva Ecija"
        },
        "NUV": {
          "stateValue": "NUV",
          "displayValue": "Nueva Vizcaya"
        },
        "PLW": {
          "stateValue": "PLW",
          "displayValue": "Palawan"
        },
        "PAM": {
          "stateValue": "PAM",
          "displayValue": "Pampanga"
        },
        "PAN": {
          "stateValue": "PAN",
          "displayValue": "Pangasinan"
        },
        "QUE": {
          "stateValue": "QUE",
          "displayValue": "Quezon Province"
        },
        "QUI": {
          "stateValue": "QUI",
          "displayValue": "Quirino"
        },
        "RIZ": {
          "stateValue": "RIZ",
          "displayValue": "Rizal"
        },
        "ROM": {
          "stateValue": "ROM",
          "displayValue": "Romblon"
        },
        "WSA": {
          "stateValue": "WSA",
          "displayValue": "Samar"
        },
        "SAR": {
          "stateValue": "SAR",
          "displayValue": "Sarangani"
        },
        "SIG": {
          "stateValue": "SIG",
          "displayValue": "Siquijor"
        },
        "SOR": {
          "stateValue": "SOR",
          "displayValue": "Sorsogon"
        },
        "SCO": {
          "stateValue": "SCO",
          "displayValue": "South Cotabato"
        },
        "SLE": {
          "stateValue": "SLE",
          "displayValue": "Southern Leyte"
        },
        "SUK": {
          "stateValue": "SUK",
          "displayValue": "Sultan Kudarat"
        },
        "SLU": {
          "stateValue": "SLU",
          "displayValue": "Sulu"
        },
        "SUN": {
          "stateValue": "SUN",
          "displayValue": "Surigao del Norte"
        },
        "SUR": {
          "stateValue": "SUR",
          "displayValue": "Surigao del Sur"
        },
        "TAR": {
          "stateValue": "TAR",
          "displayValue": "Tarlac"
        },
        "TAW": {
          "stateValue": "TAW",
          "displayValue": "Tawi-Tawi"
        },
        "ZMB": {
          "stateValue": "ZMB",
          "displayValue": "Zambales"
        },
        "ZAN": {
          "stateValue": "ZAN",
          "displayValue": "Zamboanga del Norte"
        },
        "ZAS": {
          "stateValue": "ZAS",
          "displayValue": "Zamboanga del Sur"
        },
        "ZSI": {
          "stateValue": "ZSI",
          "displayValue": "Zamboanga Sibuguey"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "PK": {
      "countryId": "PK",
      "displayValue": "Pakistan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city}-{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "PL": {
      "countryId": "PL",
      "displayValue": "Poland",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{2}-\\d{3}"
    },
    "PM": {
      "countryId": "PM",
      "displayValue": "Saint Pierre and Miquelon",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78]5\\d{2}"
    },
    "PN": {
      "countryId": "PN",
      "displayValue": "Pitcairn Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "PCRN 1ZZ"
    },
    "PR": {
      "countryId": "PR",
      "displayValue": "Puerto Rico",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} PR {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(00[679]\\d{2})(?:[ \\-](\\d{4}))?"
    },
    "PS": {
      "countryId": "PS",
      "displayValue": "Palestine",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "PT": {
      "countryId": "PT",
      "displayValue": "Portugal",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}-\\d{3}"
    },
    "PW": {
      "countryId": "PW",
      "displayValue": "Palau",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(969(?:39|40))(?:[ \\-](\\d{4}))?"
    },
    "PY": {
      "countryId": "PY",
      "displayValue": "Paraguay",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "QA": {
      "countryId": "QA",
      "displayValue": "Qatar",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "RE": {
      "countryId": "RE",
      "displayValue": "Réunion",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "9[78]4\\d{2}"
    },
    "RO": {
      "countryId": "RO",
      "displayValue": "Romania",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {state} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{6}"
    },
    "RS": {
      "countryId": "RS",
      "displayValue": "Serbia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5,6}"
    },
    "RU": {
      "countryId": "RU",
      "displayValue": "Russia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Oblast",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "ALT": {
          "stateValue": "ALT",
          "displayValue": "Altayskiy kray"
        },
        "AMU": {
          "stateValue": "AMU",
          "displayValue": "Amurskaya oblast'"
        },
        "ARK": {
          "stateValue": "ARK",
          "displayValue": "Arkhangelskaya oblast'"
        },
        "AST": {
          "stateValue": "AST",
          "displayValue": "Astrakhanskaya oblast'"
        },
        "BEL": {
          "stateValue": "BEL",
          "displayValue": "Belgorodskaya oblast'"
        },
        "BRY": {
          "stateValue": "BRY",
          "displayValue": "Bryanskaya oblast'"
        },
        "VLA": {
          "stateValue": "VLA",
          "displayValue": "Vladimirskaya oblast'"
        },
        "VGG": {
          "stateValue": "VGG",
          "displayValue": "Volgogradskaya oblast'"
        },
        "VLG": {
          "stateValue": "VLG",
          "displayValue": "Vologodskaya oblast'"
        },
        "VOR": {
          "stateValue": "VOR",
          "displayValue": "Voronezhskaya oblast'"
        },
        "YEV": {
          "stateValue": "YEV",
          "displayValue": "Evreyskaya avtonomnaya oblast'"
        },
        "ZAB": {
          "stateValue": "ZAB",
          "displayValue": "Zabaykalskiy kray"
        },
        "IVA": {
          "stateValue": "IVA",
          "displayValue": "Ivanovskaya oblast'"
        },
        "IRK": {
          "stateValue": "IRK",
          "displayValue": "Irkutskaya oblast'"
        },
        "KB": {
          "stateValue": "KB",
          "displayValue": "Kabardino-Balkarskaya Republits"
        },
        "KGD": {
          "stateValue": "KGD",
          "displayValue": "Kaliningradskaya oblast'"
        },
        "KLU": {
          "stateValue": "KLU",
          "displayValue": "Kaluzhskaya oblast'"
        },
        "KAM": {
          "stateValue": "KAM",
          "displayValue": "Kamchatskiy kray"
        },
        "KC": {
          "stateValue": "KC",
          "displayValue": "Karachaevo-Cherkesskaya Republits"
        },
        "KEM": {
          "stateValue": "KEM",
          "displayValue": "Kemerovskaya oblast'"
        },
        "KIR": {
          "stateValue": "KIR",
          "displayValue": "Kirovskaya oblast'"
        },
        "KOS": {
          "stateValue": "KOS",
          "displayValue": "Kostromskaya oblast'"
        },
        "KDA": {
          "stateValue": "KDA",
          "displayValue": "Krasnodarskiy kray"
        },
        "KYA": {
          "stateValue": "KYA",
          "displayValue": "Krasnoyarskiy kray"
        },
        "KGN": {
          "stateValue": "KGN",
          "displayValue": "Kurganskaya oblast'"
        },
        "KRS": {
          "stateValue": "KRS",
          "displayValue": "Kurskaya oblast'"
        },
        "LEN": {
          "stateValue": "LEN",
          "displayValue": "Leningradskaya oblast'"
        },
        "LIP": {
          "stateValue": "LIP",
          "displayValue": "Lipetskaya oblast'"
        },
        "MAG": {
          "stateValue": "MAG",
          "displayValue": "Magadanskaya oblast'"
        },
        "MOW": {
          "stateValue": "MOW",
          "displayValue": "Moskva"
        },
        "MOS": {
          "stateValue": "MOS",
          "displayValue": "Moskovskaya oblast'"
        },
        "MUR": {
          "stateValue": "MUR",
          "displayValue": "Murmanskaya oblast'"
        },
        "NEN": {
          "stateValue": "NEN",
          "displayValue": "Nenetskiy"
        },
        "NIZ": {
          "stateValue": "NIZ",
          "displayValue": "Nizhegorodskaya oblast'"
        },
        "NGR": {
          "stateValue": "NGR",
          "displayValue": "Novgorodskaya oblast'"
        },
        "NVS": {
          "stateValue": "NVS",
          "displayValue": "Novosibirskaya oblast'"
        },
        "OMS": {
          "stateValue": "OMS",
          "displayValue": "Omskaya oblast'"
        },
        "ORE": {
          "stateValue": "ORE",
          "displayValue": "Orenburgskaya oblast'"
        },
        "ORL": {
          "stateValue": "ORL",
          "displayValue": "Orlovskaya oblast'"
        },
        "PNZ": {
          "stateValue": "PNZ",
          "displayValue": "Penzenskaya oblast'"
        },
        "PER": {
          "stateValue": "PER",
          "displayValue": "Permskiy kray"
        },
        "PRI": {
          "stateValue": "PRI",
          "displayValue": "Primorskiy kray"
        },
        "PSK": {
          "stateValue": "PSK",
          "displayValue": "Pskovskaya oblast'"
        },
        "AD": {
          "stateValue": "AD",
          "displayValue": "Respublika Adygeya"
        },
        "AL": {
          "stateValue": "AL",
          "displayValue": "Altay Republits"
        },
        "BA": {
          "stateValue": "BA",
          "displayValue": "Bashkortostan Republits"
        },
        "BU": {
          "stateValue": "BU",
          "displayValue": "Buryatiya Republits"
        },
        "DA": {
          "stateValue": "DA",
          "displayValue": "Dagestan Republits"
        },
        "IN": {
          "stateValue": "IN",
          "displayValue": "Ingushetiya Republits"
        },
        "KL": {
          "stateValue": "KL",
          "displayValue": "Respublika Kalmykiya"
        },
        "KR": {
          "stateValue": "KR",
          "displayValue": "Kareliya Republits"
        },
        "KO": {
          "stateValue": "KO",
          "displayValue": "Komi Republits"
        },
        "Автономна Республіка Крим": {
          "stateValue": "Автономна Республіка Крим",
          "displayValue": "Respublika Krym"
        },
        "ME": {
          "stateValue": "ME",
          "displayValue": "Respublika Mariy El"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Respublika Mordoviya"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Sakha (Yakutiya) Republits"
        },
        "SE": {
          "stateValue": "SE",
          "displayValue": "Respublika Severnaya Osetiya-Alaniya"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Respublika Tatarstan"
        },
        "TY": {
          "stateValue": "TY",
          "displayValue": "Tyva Republits"
        },
        "UD": {
          "stateValue": "UD",
          "displayValue": "Udmurtskaja Respublika"
        },
        "KK": {
          "stateValue": "KK",
          "displayValue": "Khakasiya Republits"
        },
        "ROS": {
          "stateValue": "ROS",
          "displayValue": "Rostovskaya oblast'"
        },
        "RYA": {
          "stateValue": "RYA",
          "displayValue": "Ryazanskaya oblast'"
        },
        "SAM": {
          "stateValue": "SAM",
          "displayValue": "Samarskaya oblast'"
        },
        "SPE": {
          "stateValue": "SPE",
          "displayValue": "Sankt-Peterburg"
        },
        "SAR": {
          "stateValue": "SAR",
          "displayValue": "Saratovskaya oblast'"
        },
        "SAK": {
          "stateValue": "SAK",
          "displayValue": "Sakhalinskaya oblast'"
        },
        "SVE": {
          "stateValue": "SVE",
          "displayValue": "Sverdlovskaya oblast'"
        },
        "Севастополь": {
          "stateValue": "Севастополь",
          "displayValue": "Sevastopol'"
        },
        "SMO": {
          "stateValue": "SMO",
          "displayValue": "Smolenskaya oblast'"
        },
        "STA": {
          "stateValue": "STA",
          "displayValue": "Stavropolskiy kray"
        },
        "TAM": {
          "stateValue": "TAM",
          "displayValue": "Tambovskaya oblast'"
        },
        "TVE": {
          "stateValue": "TVE",
          "displayValue": "Tverskaya oblast'"
        },
        "TOM": {
          "stateValue": "TOM",
          "displayValue": "Tomskaya oblast'"
        },
        "TUL": {
          "stateValue": "TUL",
          "displayValue": "Tulskaya oblast'"
        },
        "TYU": {
          "stateValue": "TYU",
          "displayValue": "Tyumenskaya oblast'"
        },
        "ULY": {
          "stateValue": "ULY",
          "displayValue": "Ulyanovskaya oblast'"
        },
        "KHA": {
          "stateValue": "KHA",
          "displayValue": "Khabarovskiy kray"
        },
        "KHM": {
          "stateValue": "KHM",
          "displayValue": "Khanty-Mansiyskiy avtonomnyy okrug"
        },
        "CHE": {
          "stateValue": "CHE",
          "displayValue": "Chelyabinskaya oblast'"
        },
        "CE": {
          "stateValue": "CE",
          "displayValue": "Chechenskaya Republits"
        },
        "CU": {
          "stateValue": "CU",
          "displayValue": "Chuvashia"
        },
        "CHU": {
          "stateValue": "CHU",
          "displayValue": "Chukotskiy"
        },
        "YAN": {
          "stateValue": "YAN",
          "displayValue": "Yamalo-Nenetskiy"
        },
        "YAR": {
          "stateValue": "YAR",
          "displayValue": "Yaroslavskaya oblast'"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{6}"
    },
    "RW": {
      "countryId": "RW",
      "displayValue": "Rwanda",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SA": {
      "countryId": "SA",
      "displayValue": "Saudi Arabia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "SB": {
      "countryId": "SB",
      "displayValue": "Solomon Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SC": {
      "countryId": "SC",
      "displayValue": "Seychelles",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SD": {
      "countryId": "SD",
      "displayValue": "Sudan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "SE": {
      "countryId": "SE",
      "displayValue": "Sweden",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_SE-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "Post town",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3} ?\\d{2}"
    },
    "SG": {
      "countryId": "SG",
      "displayValue": "Singapore",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_SINGAPORE {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{6}"
    },
    "SH": {
      "countryId": "SH",
      "displayValue": "Saint Helena",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(?:ASCN|STHL) 1ZZ"
    },
    "SI": {
      "countryId": "SI",
      "displayValue": "Slovenia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_SI-{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "SJ": {
      "countryId": "SJ",
      "displayValue": "Svalbard and Jan Mayen",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "Post town",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "SK": {
      "countryId": "SK",
      "displayValue": "Slovakia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3} ?\\d{2}"
    },
    "SL": {
      "countryId": "SL",
      "displayValue": "Sierra Leone",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SM": {
      "countryId": "SM",
      "displayValue": "San Marino",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "4789\\d"
    },
    "SN": {
      "countryId": "SN",
      "displayValue": "Senegal",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "SO": {
      "countryId": "SO",
      "displayValue": "Somalia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AW": {
          "stateValue": "AW",
          "displayValue": "Awdal"
        },
        "BK": {
          "stateValue": "BK",
          "displayValue": "Bakool"
        },
        "BN": {
          "stateValue": "BN",
          "displayValue": "Banaadir"
        },
        "BR": {
          "stateValue": "BR",
          "displayValue": "Bari"
        },
        "BY": {
          "stateValue": "BY",
          "displayValue": "Bay"
        },
        "GA": {
          "stateValue": "GA",
          "displayValue": "Galguduud"
        },
        "GE": {
          "stateValue": "GE",
          "displayValue": "Gedo"
        },
        "HI": {
          "stateValue": "HI",
          "displayValue": "Hiiraan"
        },
        "JD": {
          "stateValue": "JD",
          "displayValue": "Jubbada Dhexe"
        },
        "JH": {
          "stateValue": "JH",
          "displayValue": "Jubbada Hoose"
        },
        "MU": {
          "stateValue": "MU",
          "displayValue": "Mudug"
        },
        "NU": {
          "stateValue": "NU",
          "displayValue": "Nugaal"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Sanaag"
        },
        "SD": {
          "stateValue": "SD",
          "displayValue": "Shabeellaha Dhexe"
        },
        "SH": {
          "stateValue": "SH",
          "displayValue": "Shabeellaha Hoose"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Sool"
        },
        "TO": {
          "stateValue": "TO",
          "displayValue": "Togdheer"
        },
        "WO": {
          "stateValue": "WO",
          "displayValue": "Woqooyi Galbeed"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "[A-Z]{2} ?\\d{5}"
    },
    "SR": {
      "countryId": "SR",
      "displayValue": "Suriname",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "BR": {
          "stateValue": "BR",
          "displayValue": "Brokopondo"
        },
        "CM": {
          "stateValue": "CM",
          "displayValue": "Commewijne"
        },
        "CR": {
          "stateValue": "CR",
          "displayValue": "Coronie"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Marowijne"
        },
        "NI": {
          "stateValue": "NI",
          "displayValue": "Nickerie"
        },
        "PR": {
          "stateValue": "PR",
          "displayValue": "Para"
        },
        "PM": {
          "stateValue": "PM",
          "displayValue": "Paramaribo"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Saramacca"
        },
        "SI": {
          "stateValue": "SI",
          "displayValue": "Sipaliwini"
        },
        "WA": {
          "stateValue": "WA",
          "displayValue": "Wanica"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SS": {
      "countryId": "SS",
      "displayValue": "South Sudan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "ST": {
      "countryId": "ST",
      "displayValue": "São Tomé and Príncipe",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SV": {
      "countryId": "SV",
      "displayValue": "El Salvador",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip}-{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AH": {
          "stateValue": "AH",
          "displayValue": "Ahuachapán"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "Cabañas"
        },
        "CH": {
          "stateValue": "CH",
          "displayValue": "Chalatenango"
        },
        "CU": {
          "stateValue": "CU",
          "displayValue": "Cuscatlán"
        },
        "LI": {
          "stateValue": "LI",
          "displayValue": "La Libertad"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "La Paz"
        },
        "UN": {
          "stateValue": "UN",
          "displayValue": "La Unión"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Morazán"
        },
        "SM": {
          "stateValue": "SM",
          "displayValue": "San Miguel"
        },
        "SS": {
          "stateValue": "SS",
          "displayValue": "San Salvador"
        },
        "SV": {
          "stateValue": "SV",
          "displayValue": "San Vicente"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Santa Ana"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Sonsonate"
        },
        "US": {
          "stateValue": "US",
          "displayValue": "Usulután"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "CP [1-3][1-7][0-2]\\d"
    },
    "SX": {
      "countryId": "SX",
      "displayValue": "Sint Maarten",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SY": {
      "countryId": "SY",
      "displayValue": "Syria",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "SZ": {
      "countryId": "SZ",
      "displayValue": "Swaziland",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "[HLMS]\\d{3}"
    },
    "TA": {
      "countryId": "TA",
      "displayValue": "Tristan da cunha",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "TDCU 1ZZ"
    },
    "TC": {
      "countryId": "TC",
      "displayValue": "Turks and Caicos Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "TKCA 1ZZ"
    },
    "TD": {
      "countryId": "TD",
      "displayValue": "Chad",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TF": {
      "countryId": "TF",
      "displayValue": "French Southern and Antarctic Lands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TG": {
      "countryId": "TG",
      "displayValue": "Togo",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TH": {
      "countryId": "TH",
      "displayValue": "Thailand",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_ {city}_{state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Bangkok"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Samut Prakan"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Nonthaburi"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Pathum Thani"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Phra Nakhon Si Ayutthaya"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Ang Thong"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Lop Buri"
        },
        "17": {
          "stateValue": "17",
          "displayValue": "Sing Buri"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Chai Nat"
        },
        "19": {
          "stateValue": "19",
          "displayValue": "Saraburi"
        },
        "20": {
          "stateValue": "20",
          "displayValue": "Chon Buri"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Rayong"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Chanthaburi"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Trat"
        },
        "24": {
          "stateValue": "24",
          "displayValue": "Chachoengsao"
        },
        "25": {
          "stateValue": "25",
          "displayValue": "Prachin Buri"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Nakhon Nayok"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Sa Kaeo"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Nakhon Ratchasima"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Buri Ram"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Surin"
        },
        "33": {
          "stateValue": "33",
          "displayValue": "Si Sa Ket"
        },
        "34": {
          "stateValue": "34",
          "displayValue": "Ubon Ratchathani"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "Yasothon"
        },
        "36": {
          "stateValue": "36",
          "displayValue": "Chaiyaphum"
        },
        "37": {
          "stateValue": "37",
          "displayValue": "Amnat Charoen"
        },
        "38": {
          "stateValue": "38",
          "displayValue": "Bueng Kan"
        },
        "39": {
          "stateValue": "39",
          "displayValue": "Nong Bua Lam Phu"
        },
        "40": {
          "stateValue": "40",
          "displayValue": "Khon Kaen"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Udon Thani"
        },
        "42": {
          "stateValue": "42",
          "displayValue": "Loei"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Nong Khai"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "Maha Sarakham"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Roi Et"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Kalasin"
        },
        "47": {
          "stateValue": "47",
          "displayValue": "Sakon Nakhon"
        },
        "48": {
          "stateValue": "48",
          "displayValue": "Nakhon Phanom"
        },
        "49": {
          "stateValue": "49",
          "displayValue": "Mukdahan"
        },
        "50": {
          "stateValue": "50",
          "displayValue": "Chiang Mai"
        },
        "51": {
          "stateValue": "51",
          "displayValue": "Lamphun"
        },
        "52": {
          "stateValue": "52",
          "displayValue": "Lampang"
        },
        "53": {
          "stateValue": "53",
          "displayValue": "Uttaradit"
        },
        "54": {
          "stateValue": "54",
          "displayValue": "Phrae"
        },
        "55": {
          "stateValue": "55",
          "displayValue": "Nan"
        },
        "56": {
          "stateValue": "56",
          "displayValue": "Phayao"
        },
        "57": {
          "stateValue": "57",
          "displayValue": "Chiang Rai"
        },
        "58": {
          "stateValue": "58",
          "displayValue": "Mae Hong Son"
        },
        "60": {
          "stateValue": "60",
          "displayValue": "Nakhon Sawan"
        },
        "61": {
          "stateValue": "61",
          "displayValue": "Uthai Thani"
        },
        "62": {
          "stateValue": "62",
          "displayValue": "Kamphaeng Phet"
        },
        "63": {
          "stateValue": "63",
          "displayValue": "Tak"
        },
        "64": {
          "stateValue": "64",
          "displayValue": "Sukhothai"
        },
        "65": {
          "stateValue": "65",
          "displayValue": "Phitsanulok"
        },
        "66": {
          "stateValue": "66",
          "displayValue": "Phichit"
        },
        "67": {
          "stateValue": "67",
          "displayValue": "Phetchabun"
        },
        "70": {
          "stateValue": "70",
          "displayValue": "Ratchaburi"
        },
        "71": {
          "stateValue": "71",
          "displayValue": "Kanchanaburi"
        },
        "72": {
          "stateValue": "72",
          "displayValue": "Suphanburi"
        },
        "73": {
          "stateValue": "73",
          "displayValue": "Nakhon Pathom"
        },
        "74": {
          "stateValue": "74",
          "displayValue": "Samut Sakhon"
        },
        "75": {
          "stateValue": "75",
          "displayValue": "Samut Songkhram"
        },
        "76": {
          "stateValue": "76",
          "displayValue": "Phetchaburi"
        },
        "77": {
          "stateValue": "77",
          "displayValue": "Prachuap Khiri Khan"
        },
        "80": {
          "stateValue": "80",
          "displayValue": "Nakhon Si Thammarat"
        },
        "81": {
          "stateValue": "81",
          "displayValue": "Krabi"
        },
        "82": {
          "stateValue": "82",
          "displayValue": "Phang Nga"
        },
        "83": {
          "stateValue": "83",
          "displayValue": "Phuket"
        },
        "84": {
          "stateValue": "84",
          "displayValue": "Surat Thani"
        },
        "85": {
          "stateValue": "85",
          "displayValue": "Ranong"
        },
        "86": {
          "stateValue": "86",
          "displayValue": "Chumpon"
        },
        "90": {
          "stateValue": "90",
          "displayValue": "Songkhla"
        },
        "91": {
          "stateValue": "91",
          "displayValue": "Satun"
        },
        "92": {
          "stateValue": "92",
          "displayValue": "Trang"
        },
        "93": {
          "stateValue": "93",
          "displayValue": "Phattalung"
        },
        "94": {
          "stateValue": "94",
          "displayValue": "Pattani"
        },
        "95": {
          "stateValue": "95",
          "displayValue": "Yala"
        },
        "96": {
          "stateValue": "96",
          "displayValue": "Narathiwat"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "TJ": {
      "countryId": "TJ",
      "displayValue": "Tajikistan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "TK": {
      "countryId": "TK",
      "displayValue": "Tokelau",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TL": {
      "countryId": "TL",
      "displayValue": "East Timor",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TM": {
      "countryId": "TM",
      "displayValue": "Turkmenistan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "TN": {
      "countryId": "TN",
      "displayValue": "Tunisia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "TO": {
      "countryId": "TO",
      "displayValue": "Tonga",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TR": {
      "countryId": "TR",
      "displayValue": "Turkey",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}/{state}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {
        "10": {
          "stateValue": "10",
          "displayValue": "Balıkesir"
        },
        "11": {
          "stateValue": "11",
          "displayValue": "Bilecik"
        },
        "12": {
          "stateValue": "12",
          "displayValue": "Bingöl"
        },
        "13": {
          "stateValue": "13",
          "displayValue": "Bitlis"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Bolu"
        },
        "15": {
          "stateValue": "15",
          "displayValue": "Burdur"
        },
        "16": {
          "stateValue": "16",
          "displayValue": "Bursa"
        },
        "17": {
          "stateValue": "17",
          "displayValue": "Çanakkale"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Çankırı"
        },
        "19": {
          "stateValue": "19",
          "displayValue": "Çorum"
        },
        "20": {
          "stateValue": "20",
          "displayValue": "Denizli"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Diyarbakır"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Edirne"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Elazığ"
        },
        "24": {
          "stateValue": "24",
          "displayValue": "Erzincan"
        },
        "25": {
          "stateValue": "25",
          "displayValue": "Erzurum"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Eskişehir"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Gaziantep"
        },
        "28": {
          "stateValue": "28",
          "displayValue": "Giresun"
        },
        "29": {
          "stateValue": "29",
          "displayValue": "Gümüşhane"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Hakkari"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Hatay"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Isparta"
        },
        "33": {
          "stateValue": "33",
          "displayValue": "Mersin"
        },
        "34": {
          "stateValue": "34",
          "displayValue": "İstanbul"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "İzmir"
        },
        "36": {
          "stateValue": "36",
          "displayValue": "Kars"
        },
        "37": {
          "stateValue": "37",
          "displayValue": "Kastamonu"
        },
        "38": {
          "stateValue": "38",
          "displayValue": "Kayseri"
        },
        "39": {
          "stateValue": "39",
          "displayValue": "Kırklareli"
        },
        "40": {
          "stateValue": "40",
          "displayValue": "Kırşehir"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Kocaeli"
        },
        "42": {
          "stateValue": "42",
          "displayValue": "Konya"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Kütahya"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "Malatya"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Manisa"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Kahramanmaraş"
        },
        "47": {
          "stateValue": "47",
          "displayValue": "Mardin"
        },
        "48": {
          "stateValue": "48",
          "displayValue": "Muğla"
        },
        "49": {
          "stateValue": "49",
          "displayValue": "Muş"
        },
        "50": {
          "stateValue": "50",
          "displayValue": "Nevşehir"
        },
        "51": {
          "stateValue": "51",
          "displayValue": "Niğde"
        },
        "52": {
          "stateValue": "52",
          "displayValue": "Ordu"
        },
        "53": {
          "stateValue": "53",
          "displayValue": "Rize"
        },
        "54": {
          "stateValue": "54",
          "displayValue": "Sakarya"
        },
        "55": {
          "stateValue": "55",
          "displayValue": "Samsun"
        },
        "56": {
          "stateValue": "56",
          "displayValue": "Siirt"
        },
        "57": {
          "stateValue": "57",
          "displayValue": "Sinop"
        },
        "58": {
          "stateValue": "58",
          "displayValue": "Sivas"
        },
        "59": {
          "stateValue": "59",
          "displayValue": "Tekirdağ"
        },
        "60": {
          "stateValue": "60",
          "displayValue": "Tokat"
        },
        "61": {
          "stateValue": "61",
          "displayValue": "Trabzon"
        },
        "62": {
          "stateValue": "62",
          "displayValue": "Tunceli"
        },
        "63": {
          "stateValue": "63",
          "displayValue": "Şanlıurfa"
        },
        "64": {
          "stateValue": "64",
          "displayValue": "Uşak"
        },
        "65": {
          "stateValue": "65",
          "displayValue": "Van"
        },
        "66": {
          "stateValue": "66",
          "displayValue": "Yozgat"
        },
        "67": {
          "stateValue": "67",
          "displayValue": "Zonguldak"
        },
        "68": {
          "stateValue": "68",
          "displayValue": "Aksaray"
        },
        "69": {
          "stateValue": "69",
          "displayValue": "Bayburt"
        },
        "70": {
          "stateValue": "70",
          "displayValue": "Karaman"
        },
        "71": {
          "stateValue": "71",
          "displayValue": "Kırıkkale"
        },
        "72": {
          "stateValue": "72",
          "displayValue": "Batman"
        },
        "73": {
          "stateValue": "73",
          "displayValue": "Şırnak"
        },
        "74": {
          "stateValue": "74",
          "displayValue": "Bartın"
        },
        "75": {
          "stateValue": "75",
          "displayValue": "Ardahan"
        },
        "76": {
          "stateValue": "76",
          "displayValue": "Iğdır"
        },
        "77": {
          "stateValue": "77",
          "displayValue": "Yalova"
        },
        "78": {
          "stateValue": "78",
          "displayValue": "Karabük"
        },
        "79": {
          "stateValue": "79",
          "displayValue": "Kilis"
        },
        "80": {
          "stateValue": "80",
          "displayValue": "Osmaniye"
        },
        "81": {
          "stateValue": "81",
          "displayValue": "Düzce"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Adana"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Adıyaman"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Afyon"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Ağrı"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Amasya"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Ankara"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Antalya"
        },
        "08": {
          "stateValue": "08",
          "displayValue": "Artvin"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Aydın"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "TT": {
      "countryId": "TT",
      "displayValue": "Trinidad and Tobago",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TV": {
      "countryId": "TV",
      "displayValue": "Tuvalu",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Island",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "FUN": {
          "stateValue": "FUN",
          "displayValue": "Funafuti"
        },
        "NMG": {
          "stateValue": "NMG",
          "displayValue": "Nanumanga"
        },
        "NMA": {
          "stateValue": "NMA",
          "displayValue": "Nanumea"
        },
        "Niulakita": {
          "stateValue": "Niulakita",
          "displayValue": "Niulakita"
        },
        "NIT": {
          "stateValue": "NIT",
          "displayValue": "Niutao"
        },
        "NUI": {
          "stateValue": "NUI",
          "displayValue": "Nui"
        },
        "NKF": {
          "stateValue": "NKF",
          "displayValue": "Nukufetau"
        },
        "NKL": {
          "stateValue": "NKL",
          "displayValue": "Nukulaelae"
        },
        "VAI": {
          "stateValue": "VAI",
          "displayValue": "Vaitupu"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "TW": {
      "countryId": "TW",
      "displayValue": "Taiwan",
      "displayFormat": "{zip}_{state}{city}_{address1}_{address2}_{company}_{firstName} {lastName}_{country}_{phone}",
      "cityDisplayValue": "District",
      "stateDisplayValue": "County",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "TXG": {
          "stateValue": "TXG",
          "displayValue": "Taichung City"
        },
        "TPE": {
          "stateValue": "TPE",
          "displayValue": "Taipei City"
        },
        "TTT": {
          "stateValue": "TTT",
          "displayValue": "Taitung County"
        },
        "TNN": {
          "stateValue": "TNN",
          "displayValue": "Tainan City"
        },
        "ILA": {
          "stateValue": "ILA",
          "displayValue": "Yilan County"
        },
        "HUA": {
          "stateValue": "HUA",
          "displayValue": "Hualien County"
        },
        "金門縣": {
          "stateValue": "金門縣",
          "displayValue": "Kinmen County"
        },
        "NAN": {
          "stateValue": "NAN",
          "displayValue": "Nantou County"
        },
        "PIF": {
          "stateValue": "PIF",
          "displayValue": "Pingtung County"
        },
        "MIA": {
          "stateValue": "MIA",
          "displayValue": "Miaoli County"
        },
        "TAO": {
          "stateValue": "TAO",
          "displayValue": "Taoyuan City"
        },
        "KHH": {
          "stateValue": "KHH",
          "displayValue": "Kaohsiung City"
        },
        "KEE": {
          "stateValue": "KEE",
          "displayValue": "Keelung City"
        },
        "連江縣": {
          "stateValue": "連江縣",
          "displayValue": "Lienchiang County"
        },
        "YUN": {
          "stateValue": "YUN",
          "displayValue": "Yunlin County"
        },
        "NWT": {
          "stateValue": "NWT",
          "displayValue": "New Taipei City"
        },
        "HSZ": {
          "stateValue": "HSZ",
          "displayValue": "Hsinchu City"
        },
        "HSQ": {
          "stateValue": "HSQ",
          "displayValue": "Hsinchu County"
        },
        "CYI": {
          "stateValue": "CYI",
          "displayValue": "Chiayi City"
        },
        "CYQ": {
          "stateValue": "CYQ",
          "displayValue": "Chiayi County"
        },
        "CHA": {
          "stateValue": "CHA",
          "displayValue": "Changhua County"
        },
        "PEN": {
          "stateValue": "PEN",
          "displayValue": "Penghu County"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{3}(?:\\d{2,3})?"
    },
    "TZ": {
      "countryId": "TZ",
      "displayValue": "Tanzania",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4,5}"
    },
    "UA": {
      "countryId": "UA",
      "displayValue": "Ukraine",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Oblast",
      "stateRequired": false,
      "cityRequired": true,
      "states": {
        "12": {
          "stateValue": "12",
          "displayValue": "Dnipropetrovsk oblast"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Donetsk oblast"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Zhytomyrs'ka oblast"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Zakarpats'ka oblast"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Zaporiz'ka oblast"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Ivano-Frankivs'ka oblast"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Kyiv city"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Kiev oblast"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "Kirovohrads'ka oblast"
        },
        "40": {
          "stateValue": "40",
          "displayValue": "Sevastopol' city"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Crimea"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Lviv oblast"
        },
        "48": {
          "stateValue": "48",
          "displayValue": "Mykolaivs'ka oblast"
        },
        "51": {
          "stateValue": "51",
          "displayValue": "Odessa oblast"
        },
        "53": {
          "stateValue": "53",
          "displayValue": "Poltavs'ka oblast"
        },
        "56": {
          "stateValue": "56",
          "displayValue": "Rivnens'ka oblast"
        },
        "59": {
          "stateValue": "59",
          "displayValue": "Sums'ka oblast"
        },
        "61": {
          "stateValue": "61",
          "displayValue": "Ternopil's'ka oblast"
        },
        "63": {
          "stateValue": "63",
          "displayValue": "Kharkiv oblast"
        },
        "65": {
          "stateValue": "65",
          "displayValue": "Khersons'ka oblast"
        },
        "68": {
          "stateValue": "68",
          "displayValue": "Khmel'nyts'ka oblast"
        },
        "71": {
          "stateValue": "71",
          "displayValue": "Cherkas'ka oblast"
        },
        "74": {
          "stateValue": "74",
          "displayValue": "Chernihivs'ka oblast"
        },
        "77": {
          "stateValue": "77",
          "displayValue": "Chernivets'ka oblast"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Vinnyts'ka oblast"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Volyns'ka oblast"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Luhans'ka oblast"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{5}"
    },
    "UG": {
      "countryId": "UG",
      "displayValue": "Uganda",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "UM": {
      "countryId": "UM",
      "displayValue": "United States Minor Outlying Islands",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "96898"
    },
    "US": {
      "countryId": "US",
      "displayValue": "United States",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}, {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "AL": {
          "stateValue": "AL",
          "displayValue": "Alabama"
        },
        "AK": {
          "stateValue": "AK",
          "displayValue": "Alaska"
        },
        "AS": {
          "stateValue": "AS",
          "displayValue": "American Samoa"
        },
        "AZ": {
          "stateValue": "AZ",
          "displayValue": "Arizona"
        },
        "AR": {
          "stateValue": "AR",
          "displayValue": "Arkansas"
        },
        "AA": {
          "stateValue": "AA",
          "displayValue": "Armed Forces (AA)"
        },
        "AE": {
          "stateValue": "AE",
          "displayValue": "Armed Forces (AE)"
        },
        "AP": {
          "stateValue": "AP",
          "displayValue": "Armed Forces (AP)"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "California"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Colorado"
        },
        "CT": {
          "stateValue": "CT",
          "displayValue": "Connecticut"
        },
        "DE": {
          "stateValue": "DE",
          "displayValue": "Delaware"
        },
        "DC": {
          "stateValue": "DC",
          "displayValue": "District of Columbia"
        },
        "FL": {
          "stateValue": "FL",
          "displayValue": "Florida"
        },
        "GA": {
          "stateValue": "GA",
          "displayValue": "Georgia"
        },
        "GU": {
          "stateValue": "GU",
          "displayValue": "Guam"
        },
        "HI": {
          "stateValue": "HI",
          "displayValue": "Hawaii"
        },
        "ID": {
          "stateValue": "ID",
          "displayValue": "Idaho"
        },
        "IL": {
          "stateValue": "IL",
          "displayValue": "Illinois"
        },
        "IN": {
          "stateValue": "IN",
          "displayValue": "Indiana"
        },
        "IA": {
          "stateValue": "IA",
          "displayValue": "Iowa"
        },
        "KS": {
          "stateValue": "KS",
          "displayValue": "Kansas"
        },
        "KY": {
          "stateValue": "KY",
          "displayValue": "Kentucky"
        },
        "LA": {
          "stateValue": "LA",
          "displayValue": "Louisiana"
        },
        "ME": {
          "stateValue": "ME",
          "displayValue": "Maine"
        },
        "MH": {
          "stateValue": "MH",
          "displayValue": "Marshall Islands"
        },
        "MD": {
          "stateValue": "MD",
          "displayValue": "Maryland"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Massachusetts"
        },
        "MI": {
          "stateValue": "MI",
          "displayValue": "Michigan"
        },
        "FM": {
          "stateValue": "FM",
          "displayValue": "Micronesia"
        },
        "MN": {
          "stateValue": "MN",
          "displayValue": "Minnesota"
        },
        "MS": {
          "stateValue": "MS",
          "displayValue": "Mississippi"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Missouri"
        },
        "MT": {
          "stateValue": "MT",
          "displayValue": "Montana"
        },
        "NE": {
          "stateValue": "NE",
          "displayValue": "Nebraska"
        },
        "NV": {
          "stateValue": "NV",
          "displayValue": "Nevada"
        },
        "NH": {
          "stateValue": "NH",
          "displayValue": "New Hampshire"
        },
        "NJ": {
          "stateValue": "NJ",
          "displayValue": "New Jersey"
        },
        "NM": {
          "stateValue": "NM",
          "displayValue": "New Mexico"
        },
        "NY": {
          "stateValue": "NY",
          "displayValue": "New York"
        },
        "NC": {
          "stateValue": "NC",
          "displayValue": "North Carolina"
        },
        "ND": {
          "stateValue": "ND",
          "displayValue": "North Dakota"
        },
        "MP": {
          "stateValue": "MP",
          "displayValue": "Northern Mariana Islands"
        },
        "OH": {
          "stateValue": "OH",
          "displayValue": "Ohio"
        },
        "OK": {
          "stateValue": "OK",
          "displayValue": "Oklahoma"
        },
        "OR": {
          "stateValue": "OR",
          "displayValue": "Oregon"
        },
        "PW": {
          "stateValue": "PW",
          "displayValue": "Palau"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "Pennsylvania"
        },
        "PR": {
          "stateValue": "PR",
          "displayValue": "Puerto Rico"
        },
        "RI": {
          "stateValue": "RI",
          "displayValue": "Rhode Island"
        },
        "SC": {
          "stateValue": "SC",
          "displayValue": "South Carolina"
        },
        "SD": {
          "stateValue": "SD",
          "displayValue": "South Dakota"
        },
        "TN": {
          "stateValue": "TN",
          "displayValue": "Tennessee"
        },
        "TX": {
          "stateValue": "TX",
          "displayValue": "Texas"
        },
        "UT": {
          "stateValue": "UT",
          "displayValue": "Utah"
        },
        "VT": {
          "stateValue": "VT",
          "displayValue": "Vermont"
        },
        "VI": {
          "stateValue": "VI",
          "displayValue": "Virgin Islands"
        },
        "VA": {
          "stateValue": "VA",
          "displayValue": "Virginia"
        },
        "WA": {
          "stateValue": "WA",
          "displayValue": "Washington"
        },
        "WV": {
          "stateValue": "WV",
          "displayValue": "West Virginia"
        },
        "WI": {
          "stateValue": "WI",
          "displayValue": "Wisconsin"
        },
        "WY": {
          "stateValue": "WY",
          "displayValue": "Wyoming"
        }
      },
      "postalCodeRequired": true,
      "postalCodeRegex": "(\\d{5})(?:[ \\-](\\d{4}))?"
    },
    "UY": {
      "countryId": "UY",
      "displayValue": "Uruguay",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city} {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "AR": {
          "stateValue": "AR",
          "displayValue": "Artigas"
        },
        "CA": {
          "stateValue": "CA",
          "displayValue": "Canelones"
        },
        "CL": {
          "stateValue": "CL",
          "displayValue": "Cerro Largo"
        },
        "CO": {
          "stateValue": "CO",
          "displayValue": "Colonia"
        },
        "DU": {
          "stateValue": "DU",
          "displayValue": "Durazno"
        },
        "FS": {
          "stateValue": "FS",
          "displayValue": "Flores"
        },
        "FD": {
          "stateValue": "FD",
          "displayValue": "Florida"
        },
        "LA": {
          "stateValue": "LA",
          "displayValue": "Lavalleja"
        },
        "MA": {
          "stateValue": "MA",
          "displayValue": "Maldonado"
        },
        "MO": {
          "stateValue": "MO",
          "displayValue": "Montevideo"
        },
        "PA": {
          "stateValue": "PA",
          "displayValue": "Paysandú"
        },
        "RN": {
          "stateValue": "RN",
          "displayValue": "Río Negro"
        },
        "RV": {
          "stateValue": "RV",
          "displayValue": "Rivera"
        },
        "RO": {
          "stateValue": "RO",
          "displayValue": "Rocha"
        },
        "SA": {
          "stateValue": "SA",
          "displayValue": "Salto"
        },
        "SJ": {
          "stateValue": "SJ",
          "displayValue": "San José"
        },
        "SO": {
          "stateValue": "SO",
          "displayValue": "Soriano"
        },
        "TA": {
          "stateValue": "TA",
          "displayValue": "Tacuarembó"
        },
        "TT": {
          "stateValue": "TT",
          "displayValue": "Treinta y Tres"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "UZ": {
      "countryId": "UZ",
      "displayValue": "Uzbekistan",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{6}"
    },
    "VA": {
      "countryId": "VA",
      "displayValue": "Holy See",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "00120"
    },
    "VC": {
      "countryId": "VC",
      "displayValue": "Saint Vincent and the Grenadines",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "VC\\d{4}"
    },
    "VE": {
      "countryId": "VE",
      "displayValue": "Venezuela",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {zip}, {state}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": true,
      "cityRequired": true,
      "states": {
        "Z": {
          "stateValue": "Z",
          "displayValue": "Amazonas"
        },
        "B": {
          "stateValue": "B",
          "displayValue": "Anzoátegui"
        },
        "C": {
          "stateValue": "C",
          "displayValue": "Apure"
        },
        "D": {
          "stateValue": "D",
          "displayValue": "Aragua"
        },
        "E": {
          "stateValue": "E",
          "displayValue": "Barinas"
        },
        "F": {
          "stateValue": "F",
          "displayValue": "Bolívar"
        },
        "G": {
          "stateValue": "G",
          "displayValue": "Carabobo"
        },
        "H": {
          "stateValue": "H",
          "displayValue": "Cojedes"
        },
        "Y": {
          "stateValue": "Y",
          "displayValue": "Delta Amacuro"
        },
        "W": {
          "stateValue": "W",
          "displayValue": "Dependencias Federales"
        },
        "A": {
          "stateValue": "A",
          "displayValue": "Distrito Federal"
        },
        "I": {
          "stateValue": "I",
          "displayValue": "Falcón"
        },
        "J": {
          "stateValue": "J",
          "displayValue": "Guárico"
        },
        "K": {
          "stateValue": "K",
          "displayValue": "Lara"
        },
        "L": {
          "stateValue": "L",
          "displayValue": "Mérida"
        },
        "M": {
          "stateValue": "M",
          "displayValue": "Miranda"
        },
        "N": {
          "stateValue": "N",
          "displayValue": "Monagas"
        },
        "O": {
          "stateValue": "O",
          "displayValue": "Nueva Esparta"
        },
        "P": {
          "stateValue": "P",
          "displayValue": "Portuguesa"
        },
        "R": {
          "stateValue": "R",
          "displayValue": "Sucre"
        },
        "S": {
          "stateValue": "S",
          "displayValue": "Táchira"
        },
        "T": {
          "stateValue": "T",
          "displayValue": "Trujillo"
        },
        "X": {
          "stateValue": "X",
          "displayValue": "Vargas"
        },
        "U": {
          "stateValue": "U",
          "displayValue": "Yaracuy"
        },
        "V": {
          "stateValue": "V",
          "displayValue": "Zulia"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{4}"
    },
    "VG": {
      "countryId": "VG",
      "displayValue": "Virgin Islands (British)",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "VG\\d{4}"
    },
    "VI": {
      "countryId": "VI",
      "displayValue": "Virgin Islands (U.S.)",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city} {state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "State",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?"
    },
    "VN": {
      "countryId": "VN",
      "displayValue": "Vietnam",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{state} {zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {
        "13": {
          "stateValue": "13",
          "displayValue": "Quang Ninh Province"
        },
        "14": {
          "stateValue": "14",
          "displayValue": "Hoa Binh Province"
        },
        "18": {
          "stateValue": "18",
          "displayValue": "Ninh Binh Province"
        },
        "20": {
          "stateValue": "20",
          "displayValue": "Thai Binh Province"
        },
        "21": {
          "stateValue": "21",
          "displayValue": "Thanh Hoa Province"
        },
        "22": {
          "stateValue": "22",
          "displayValue": "Nghe An Province"
        },
        "23": {
          "stateValue": "23",
          "displayValue": "Ha Tinh Province"
        },
        "24": {
          "stateValue": "24",
          "displayValue": "Quang Binh Province"
        },
        "25": {
          "stateValue": "25",
          "displayValue": "Quang Tri Province"
        },
        "26": {
          "stateValue": "26",
          "displayValue": "Thua Thien-Hue Province"
        },
        "27": {
          "stateValue": "27",
          "displayValue": "Quang Nam Province"
        },
        "28": {
          "stateValue": "28",
          "displayValue": "Kon Tum Province"
        },
        "29": {
          "stateValue": "29",
          "displayValue": "Quang Ngai Province"
        },
        "30": {
          "stateValue": "30",
          "displayValue": "Gia Lai Province"
        },
        "31": {
          "stateValue": "31",
          "displayValue": "Binh Dinh Province"
        },
        "32": {
          "stateValue": "32",
          "displayValue": "Phu Yen Province"
        },
        "33": {
          "stateValue": "33",
          "displayValue": "Dak Lak Province"
        },
        "34": {
          "stateValue": "34",
          "displayValue": "Khanh Hoa Province"
        },
        "35": {
          "stateValue": "35",
          "displayValue": "Lam Dong Province"
        },
        "36": {
          "stateValue": "36",
          "displayValue": "Ninh Thuan Province"
        },
        "37": {
          "stateValue": "37",
          "displayValue": "Tay Ninh Province"
        },
        "39": {
          "stateValue": "39",
          "displayValue": "Dong Nai Province"
        },
        "40": {
          "stateValue": "40",
          "displayValue": "Binh Thuan Province"
        },
        "41": {
          "stateValue": "41",
          "displayValue": "Long An Province"
        },
        "43": {
          "stateValue": "43",
          "displayValue": "Ba Ria-Vung Tau Province"
        },
        "44": {
          "stateValue": "44",
          "displayValue": "An Giang Province"
        },
        "45": {
          "stateValue": "45",
          "displayValue": "Dong Thap Province"
        },
        "46": {
          "stateValue": "46",
          "displayValue": "Tien Giang Province"
        },
        "47": {
          "stateValue": "47",
          "displayValue": "Kien Giang Province"
        },
        "49": {
          "stateValue": "49",
          "displayValue": "Vinh Long Province"
        },
        "50": {
          "stateValue": "50",
          "displayValue": "Ben Tre Province"
        },
        "51": {
          "stateValue": "51",
          "displayValue": "Tra Vinh Province"
        },
        "52": {
          "stateValue": "52",
          "displayValue": "Soc Trang Province"
        },
        "53": {
          "stateValue": "53",
          "displayValue": "Bac Kan Province"
        },
        "54": {
          "stateValue": "54",
          "displayValue": "Bac Giang Province"
        },
        "55": {
          "stateValue": "55",
          "displayValue": "Bac Lieu Province"
        },
        "56": {
          "stateValue": "56",
          "displayValue": "Bac Ninh Province"
        },
        "57": {
          "stateValue": "57",
          "displayValue": "Binh Duong Province"
        },
        "58": {
          "stateValue": "58",
          "displayValue": "Binh Phuoc Province"
        },
        "59": {
          "stateValue": "59",
          "displayValue": "Ca Mau Province"
        },
        "61": {
          "stateValue": "61",
          "displayValue": "Hai Duong Province"
        },
        "63": {
          "stateValue": "63",
          "displayValue": "Ha Nam Province"
        },
        "66": {
          "stateValue": "66",
          "displayValue": "Hung Yen Province"
        },
        "67": {
          "stateValue": "67",
          "displayValue": "Nam Dinh Province"
        },
        "68": {
          "stateValue": "68",
          "displayValue": "Phu Tho Province"
        },
        "69": {
          "stateValue": "69",
          "displayValue": "Thai Nguyen Province"
        },
        "70": {
          "stateValue": "70",
          "displayValue": "Vinh Phuc Province"
        },
        "71": {
          "stateValue": "71",
          "displayValue": "Dien Bien Province"
        },
        "72": {
          "stateValue": "72",
          "displayValue": "Dak Nong Province"
        },
        "73": {
          "stateValue": "73",
          "displayValue": "Hau Giang Province"
        },
        "04": {
          "stateValue": "04",
          "displayValue": "Cao Bang Province"
        },
        "CT": {
          "stateValue": "CT",
          "displayValue": "Can Tho City"
        },
        "DN": {
          "stateValue": "DN",
          "displayValue": "Da Nang City"
        },
        "03": {
          "stateValue": "03",
          "displayValue": "Ha Giang Province"
        },
        "HN": {
          "stateValue": "HN",
          "displayValue": "Hanoi City"
        },
        "HP": {
          "stateValue": "HP",
          "displayValue": "Haiphong City"
        },
        "01": {
          "stateValue": "01",
          "displayValue": "Lai Chau Province"
        },
        "09": {
          "stateValue": "09",
          "displayValue": "Lang Song Province"
        },
        "02": {
          "stateValue": "02",
          "displayValue": "Lao Cai Province"
        },
        "05": {
          "stateValue": "05",
          "displayValue": "Son La Province"
        },
        "SG": {
          "stateValue": "SG",
          "displayValue": "Ho Chi Minh City"
        },
        "07": {
          "stateValue": "07",
          "displayValue": "Tuyen Quang Province"
        },
        "06": {
          "stateValue": "06",
          "displayValue": "Yen Bai Province"
        }
      },
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}\\d?"
    },
    "VU": {
      "countryId": "VU",
      "displayValue": "Vanuatu",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "WF": {
      "countryId": "WF",
      "displayValue": "Wallis and Futuna",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "986\\d{2}"
    },
    "WS": {
      "countryId": "WS",
      "displayValue": "Samoa",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "XK": {
      "countryId": "XK",
      "displayValue": "Republic of Kosovo",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "[1-7]\\d{4}"
    },
    "YE": {
      "countryId": "YE",
      "displayValue": "Yemen",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    },
    "YT": {
      "countryId": "YT",
      "displayValue": "Mayotte",
      "displayFormat": "{company}_{firstName} {lastName}_{address1}_{address2}_{zip} {city} _{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "976\\d{2}"
    },
    "ZA": {
      "countryId": "ZA",
      "displayValue": "South Africa",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}__{city}_{zip}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": true,
      "states": {},
      "postalCodeRequired": true,
      "postalCodeRegex": "\\d{4}"
    },
    "ZM": {
      "countryId": "ZM",
      "displayValue": "Zambia",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{zip} {city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": "\\d{5}"
    },
    "ZW": {
      "countryId": "ZW",
      "displayValue": "Zimbabwe",
      "displayFormat": "{firstName} {lastName}_{company}_{address1}_{address2}_{city}_{country}_{phone}",
      "cityDisplayValue": "City",
      "stateDisplayValue": "Region",
      "stateRequired": false,
      "cityRequired": false,
      "states": {},
      "postalCodeRequired": false,
      "postalCodeRegex": ""
    }
  }
};

export default countriesAndStates

const {countries} = countriesAndStates
const countryEntries = Object.entries(countries)
countryEntries.sort(([, a], [, b]) => {
  const aDisplayValue = a.displayValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const bDisplayValue = b.displayValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if(aDisplayValue < bDisplayValue) { return -1; }
  if(aDisplayValue > bDisplayValue) { return 1; }
  return 0;
});

export const ascCountryCodes = (() => {
  const countryCodes = countryEntries.map(e => e[0]);
  const topCountryCodes = ['SG', 'MY']
  _.pull(countryCodes, ...topCountryCodes);
  return [...topCountryCodes, ...countryCodes];
})();

function renderLineTemplate(countryFieldSettings: Country, fields: string, address: UserAddress) {
  const mapper = {
    fullName: 'firstName',
    address: 'address1',
    unitNumber: 'address2',
    city: 'city',
    country: 'country',
    phoneNumber: 'phone',
    postalCode: 'zip',
    state: 'state'
  };

  let line = fields
    .replace('{company}', '')
    .replace('{lastName}', '');
  for (const [key, formatKey] of Object.entries(mapper) as [keyof typeof mapper, string][]) {
    let value = address[key];

    switch (key) {
      case 'country':
        value = countriesAndStates.countries[address.country].displayValue;
        break;
      case 'state': {
        if (!address.state) {
          break;
        }

        const stateData = countriesAndStates.countries[address.country].states[address.state];
        if (stateData) {
          value = stateData.displayValue;
        }
        break;
      }
    }
    line = line.replace(`{${formatKey}}`, value || '');
  }

  return line;
}

export function formatAddress(address: UserAddress) {
  const countryFieldSettings = countriesAndStates.countries[address.country];
  return countryFieldSettings.displayFormat
    .split('_')
    .map(fields => renderLineTemplate(countryFieldSettings, fields, address).trim())
    .filter(line => line.length > 0);
}